import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Anderson Acevedo
 * 
 * @version jdesk_1.01.0003
 */
/**
 * Custom con funciones adicionales al Formulario
 **/
class CustomAbrirInventario extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);


        this.limpiarCamposConteo = this.limpiarCamposConteo.bind(this);
        this.gridOptionsComponentes = Object.assign({}, this.gridOptions);
        this.onSelectionChangedPrincipal = this.onSelectionChangedPrincipal.bind(this);
        this.gridOptionsComponentes['onSelectionChanged'] = this.onSelectionChangedPrincipal;

        this.gridOptionsNuevo = Object.assign({}, this.gridOptions);
        this.onSelectionChangedNuevo = this.onSelectionChangedNuevo.bind(this);
        this.gridOptionsNuevo['onSelectionChanged'] = this.onSelectionChangedNuevo;
        this.gridOptionsNuevo['rowData'] = [];
        this.fila_seleccionada_nuevo = [];

        this.gridOptionsUsuarios = Object.assign({}, this.gridOptions);
        this.onSelectionChangedUsuarios = this.onSelectionChangedUsuarios.bind(this);
        this.gridOptionsUsuarios['onSelectionChanged'] = this.onSelectionChangedUsuarios;
        this.fila_seleccionada_usuarios = [];

        this.gridOptionsInformes = Object.assign({}, this.gridOptions);
        this.onSelectionChangedInformes = this.onSelectionChangedInformes.bind(this);
        this.gridOptionsInformes['onSelectionChanged'] = this.onSelectionChangedInformes;
        this.fila_seleccionada_informes = [];

        this.gridOptionsComponentesItems = Object.assign({}, this.gridOptions);
        this.onSelectionChangedNada = this.onSelectionChangedNada.bind(this);
        this.gridOptionsComponentesItems['onSelectionChanged'] = this.onSelectionChangedNada;


        this.gridOptionsComponentesRecontar = Object.assign({}, this.gridOptions);
        this.onSelectionChangedRecontar = this.onSelectionChangedNada.bind(this);
        this.gridOptionsComponentesRecontar['onSelectionChanged'] = this.onSelectionChangedNada;


        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);
        this.traerInventarios = this.traerInventarios.bind(this);
        this.sucesstraerInventarios = this.sucesstraerInventarios.bind(this);
        this.funcionesInicial = this.funcionesInicial.bind(this);

        this.ocultarCampoNuevosArticulos = this.ocultarCampoNuevosArticulos.bind(this);


        this.sucesstraerArticulosTemp = this.sucesstraerArticulosTemp.bind(this);
        this.traerArticulosTemp = this.traerArticulosTemp.bind(this);
        this.agregarArticulo = this.agregarArticulo.bind(this);
        this.successAgregarArticulo = this.successAgregarArticulo.bind(this);
        this.guardarArticulosFinales = this.guardarArticulosFinales.bind(this);
        this.successGuardarArticulosFinales = this.successGuardarArticulosFinales.bind(this);

        this.successEliminarArticuloNuevo = this.successEliminarArticuloNuevo.bind(this);
        this.eliminarArticuloNuevo = this.eliminarArticuloNuevo.bind(this);
        this.funcionesNuevoInventario = this.funcionesNuevoInventario.bind(this);
        this.crearTemporalNuevo = this.crearTemporalNuevo.bind(this);
        this.successcrearTemporalNuevo = this.successcrearTemporalNuevo.bind(this);


        this.succcessCambiarUsuario = this.succcessCambiarUsuario.bind(this);
        this.cambiarUsuario = this.cambiarUsuario.bind(this);
        this.successcambiarEstado = this.successcambiarEstado.bind(this);
        this.cambiarEstado = this.cambiarEstado.bind(this);
        this.successcrearTemporalUsuarios = this.successcrearTemporalUsuarios.bind(this);
        this.crearTemporalUsuarios = this.crearTemporalUsuarios.bind(this);
        this.traerUsuariosTemp = this.traerUsuariosTemp.bind(this);
        this.sucesstraerUsuariosTemp = this.sucesstraerUsuariosTemp.bind(this);
        this.sucesssuccessTraerUsuarios = this.sucesssuccessTraerUsuarios.bind(this);
        this.traerUsuarios = this.traerUsuarios.bind(this);
        this.funcionesUsuarios = this.funcionesUsuarios.bind(this);

        this.eliminarInventario = this.eliminarInventario.bind(this);
        this.successEliminarInventario = this.successEliminarInventario.bind(this);


        this.confirmarIniciar = this.confirmarIniciar.bind(this);
        this.successconfirmarIniciar = this.successconfirmarIniciar.bind(this);
        this.sucessinicioValidaciones = this.sucessinicioValidaciones.bind(this);
        this.inicioValidaciones = this.inicioValidaciones.bind(this);
        this.funcionesIniciarInventario = this.funcionesIniciarInventario.bind(this);

        this.traerUbicacionesBodega = this.traerUbicacionesBodega.bind(this);
        this.sucesstraerUbicacionesBodega = this.sucesstraerUbicacionesBodega.bind(this);


        this.funcionesAgregarArticulo = this.funcionesAgregarArticulo.bind(this);
        this.guardarArticuloUbicacion = this.guardarArticuloUbicacion.bind(this);
        this.successguardarArticuloUbicacion = this.successguardarArticuloUbicacion.bind(this);
        this.ubicaiones = this.ubicaiones.bind(this);
        this.successUbicacionesWms = this.successUbicacionesWms.bind(this);

        this.successBodegaWms = this.successBodegaWms.bind(this);
        this.successZonaWms = this.successZonaWms.bind(this);
        this.cargarRack = this.cargarRack.bind(this);
        this.successRackwms = this.successRackwms.bind(this);
        this.cargarColumna = this.cargarColumna.bind(this);
        this.successColumnawms = this.successColumnawms.bind(this);
        this.tipoubicacion = this.tipoubicacion.bind(this);
        this.successTipoUbicacion = this.successTipoUbicacion.bind(this);


        this.funcionesIngresar = this.funcionesIngresar.bind(this);
        this.funcionQueSeEjecutaAlClick = this.funcionQueSeEjecutaAlClick.bind(this);


        this.funcionesIngresar = this.funcionesIngresar.bind(this);
        this.validarConteoAgregar = this.validarConteoAgregar.bind(this);
        this.successAgregarConteo = this.successAgregarConteo.bind(this);
        this.ocultarConteo = this.ocultarConteo.bind(this);
        this.validarCodigo = this.validarCodigo.bind(this);
        this.sucessValidarCodigo = this.sucessValidarCodigo.bind(this);
        this.traerConteo = this.traerConteo.bind(this);
        this.sucesstraerConteo = this.sucesstraerConteo.bind(this);
        this.traerInfoArticulo = this.traerInfoArticulo.bind(this);
        this.sucessTraerArticulo = this.sucessTraerArticulo.bind(this);
        this.sucessTraerArticulo2 = this.sucessTraerArticulo2.bind(this);
        this.changeKeyUpCustom = this.changeKeyUpCustom.bind(this);
        this.traerInfoInicial = this.traerInfoInicial.bind(this);
        this.sucesstraerInfoInicial = this.sucesstraerInfoInicial.bind(this);
        this.mostrarConteo = this.mostrarConteo.bind(this);




        //imprimir---------->
        this.abrirImprimir = this.abrirImprimir.bind(this);
        this.isJson = this.isJson.bind(this);
        this.genearModalGlobales = this.genearModalGlobales.bind(this);
        this.sucessTraerDatos = this.sucessTraerDatos.bind(this);

        this.generarExcelTabla3 = this.generarExcelTabla3.bind(this);
        this.generarPdfTabla3 = this.generarPdfTabla3.bind(this);
        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeEmailFallo = this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado = this.mostrarMensajeEmailEnviado.bind(this);
        this.successEnviarCorreo = this.successEnviarCorreo.bind(this);
        this.enviarCorreoTerceros = this.enviarCorreoTerceros.bind(this);
        this.procesar = this.procesar.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);


        this.ocultarInformes = this.ocultarInformes.bind(this);
        this.crearTemporalDiferenciasReales = this.crearTemporalDiferenciasReales.bind(this);
        this.successcrearTemporalDiferenciasReales = this.successcrearTemporalDiferenciasReales.bind(this);
        this.traerTablaInformes = this.traerTablaInformes.bind(this);
        this.sucesstraerTablaInformes = this.sucesstraerTablaInformes.bind(this);


        this.successeliminarArticuloDifReales = this.successeliminarArticuloDifReales.bind(this);
        this.eliminarArticuloDifReales = this.eliminarArticuloDifReales.bind(this);
        this.successautorizarAsentar = this.successautorizarAsentar.bind(this);
        this.autorizarAsentar = this.autorizarAsentar.bind(this);
        this.successAsentar = this.successAsentar.bind(this);
        this.asentar = this.asentar.bind(this);
        this.asentarSubgrupo = this.asentarSubgrupo.bind(this);

        this.successAsentarGeneralUbi = this.successAsentarGeneralUbi.bind(this);
        this.asentarGeneralUbi = this.asentarGeneralUbi.bind(this);
        this.successprevioAsentarUbi = this.successprevioAsentarUbi.bind(this);
        this.previoAsentarUbi = this.previoAsentarUbi.bind(this);
        this.crearTemporalDiferenciasRealesUbi = this.crearTemporalDiferenciasRealesUbi.bind(this);
        this.successCrearTemporalDiferenciasRealesUbi = this.successCrearTemporalDiferenciasRealesUbi.bind(this);


        this.successrealizarRecontar = this.successrealizarRecontar.bind(this);
        this.realizarRecontar = this.realizarRecontar.bind(this);

        this.crearTemporalDiferenciasRealesGandola = this.crearTemporalDiferenciasRealesGandola.bind(this);
        this.successCrearTemporalDiferenciasRealesGandola = this.successCrearTemporalDiferenciasRealesGandola.bind(this);


        this.reiniciarConteo = this.reiniciarConteo.bind(this);
        this.successReiniciarConteo = this.successReiniciarConteo.bind(this);
        this.successActualizarArticulos = this.successActualizarArticulos.bind(this);
        this.actualizarArticulos = this.actualizarArticulos.bind(this);
        this.successAsentarInventario = this.successAsentarInventario.bind(this);
        this.asentarInventario = this.asentarInventario.bind(this);
        this.bloquearInventario = this.bloquearInventario.bind(this);
        this.successBloquearInventario = this.successBloquearInventario.bind(this);

        
        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.servicio = '';
        this.sucursal_ingreso = '';
        this.numero_decimales = 2;
        this.fila_seleccionada = [];
        this.nuevo_inventario = false; //I0101--->autorización crear nuevo
        this.permite_sumar_bodega = false;
        this.iniciar_inventario = false;
        this.permite_eliminar_inventario = false;
        this.agregar_inventario = false;
        this.entrar_inventario = false;


        this.unificado = 'S';
        this.sucursal = '';
        this.tabla = '';
        this.bodega = '';
        this.wms = '';
        this.tipo = '';

        //ingresar-->props
        this.campo_costo = '';
        this.por_gondola = '';
        this.acumula = '';
        this.cantidad_permitida = '';
        this.prioridad_barras = '';
        this.conteo1 = false;
        this.conteo2 = false;
        this.conteo3 = false;
        this.lista_diferencias1_2 = false;
        this.diferencias_reales = false;
        this.tabla_por_gondola = '';
        this.eliminar_articulo = false;
        this.puede_asentar = false;
        this.asentar_subgrupo = false;
        this.bloquear_inventario = false;
        this.asentar_inventario = false;
        this.actualizar_articulos = false;
        this.reiniciar_conteo = false;
        this.diferencias_reales_gandola = false;


        //articulo
        this.datos_articulo_aux = [];
        this.respuesta_completa = false;
        this.cambiar_prioridad = false;


        this.nuevo = false;
        this.conteo = '';
        this.ingreso = false;

        this.tipo_servicio = 'inve-abririnventario';
        this.nombre_servicio = '';
        this.nombre_archivo = '';
        this.informes = '';
        this.pantalla = false;
        //diferencias reales aux
        this.aux_conteo = '';
        this.aux_bodega = '';
        this.aux_gondola = '';

        this.aux_ubicacion = '';
        this.aux_seccion = '';
        this.operacion_actual = '';
        this.accion = '';//asentar
        this.mostrar_general = false;//asentar
        this.bt_iniciar_inventario=false;

    }


    initForm() {
        console.log('Formulario CustomAbrirInventario,  @version: jdesk_1.01.0003, @author:Anderson Acevedo');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerPropiedades();
        this.funcionesInicial();
        this.funcionesNuevoInventario();
        this.funcionesAgregarArticulo();
        this.funcionesIniciarInventario();
        this.funcionesUsuarios();
        this.funcionesIngresar();
        //this.getField('TabJaivana_263').setDisabledButtonTab(true);

        //funcion imprimir-->
        this.getField('ch_excel').setOnChange((props) => {
            if (this.getField('ch_excel').getValue() === 'false') {
                this.getField('ch_pdf').setValueSwitch(false);
                this.getField('ch_pantalla').setValueSwitch(false);
                this.operacion_actual = 'excel';
                this.habilitarCorreo();
            }
        });

        this.getField('generar_archivo').setClick(() => this.procesar());


        this.getField('ch_pdf').setOnChange((props) => {
            if (this.getField('ch_pdf').getValue() === 'false') {
                this.getField('ch_excel').setValueSwitch(false);
                this.getField('ch_pantalla').setValueSwitch(false);
                this.operacion_actual = 'pdf';
                this.habilitarCorreo();
            }
        });

        this.getField('ch_pantalla').setOnChange((props) => {
            if (this.getField('ch_pantalla').getValue() === 'false') {
                this.getField('ch_excel').setValueSwitch(false);
                this.getField('ch_pdf').setValueSwitch(false);
                this.operacion_actual = 'pantalla';
                this.deshabilitarCorreo();
            } else {
                this.habilitarCorreo();
            }
        });
    }

    onSelectionChangedPrincipal() {
        this.fila_seleccionada = this.gridOptionsComponentes.api.getSelectedRows();
        if (this.fila_seleccionada.length > 0) {
            let estado = this.fila_seleccionada[0].estado;
            let wms = this.fila_seleccionada[0].wms;
            switch (estado) {
                case "A":
                    this.getField('bt_ingresar_inventario').setDisabled(false);
                    this.getField('bt_eliminar_inventario').setDisabled(true);
                    this.getField('bt_iniciar_inventario').setDisabled(true);
                    this.getField('bt_agregar_articulos').setDisabled(false);
                    break;
                case "B":
                    this.getField('bt_ingresar_inventario').setDisabled(true);
                    this.getField('bt_eliminar_inventario').setDisabled(false);
                    this.getField('bt_iniciar_inventario').setDisabled(false);
                    this.getField('bt_agregar_articulos').setDisabled(false);
                    break;
                case "C":
                    this.getField('bt_ingresar_inventario').setDisabled(false);
                    this.getField('bt_eliminar_inventario').setDisabled(false);
                    this.getField('bt_iniciar_inventario').setDisabled(false);
                    this.getField('bt_agregar_articulos').setDisabled(true);
                    break;
                default:
                    this.getField('bt_ingresar_inventario').setDisabled(true);
                    this.getField('bt_eliminar_inventario').setDisabled(true);
                    this.getField('bt_iniciar_inventario').setDisabled(true);
                    this.getField('bt_agregar_articulos').setDisabled(true);
                    break;
            }
            this.getField('bt_asignar_usuarios').setVisible((wms.toString().trim() !== '' && wms === 'S') ? true : false);
        }

    }

    //modal ingresar inventario--->

    funcionQueSeEjecutaAlClick(event, newValue) {
        //this.getField('TabJaivana_263').setTabNumber(newValue+1);
        if (newValue + 1 === 1) {
            this.ocultarConteo();
        } else if (newValue + 1 === 2) {
            this.ocultarInformes();
        }
    }

    funcionesIngresar() {
        this.getField("TabJaivana_263").setClickTab(this.funcionQueSeEjecutaAlClick);

        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} },
        { 'text': 'Conteo 1', 'value': '1', 'campos_cambian': {} },
        { 'text': 'Conteo 2', 'value': '2', 'campos_cambian': {} },
        { 'text': 'Conteo 3', 'value': '3', 'campos_cambian': {} }
        ];

        this.getField('select_conteo').setOptions(opciones);



        this.getField("select_bodegas").setOnBlur(() => {
            if (this.getField('select_bodegas').getValue() === '')
                this.getField('select_bodegas').setError(false, '')
        });

        this.getField("la_gondola2").setOnBlur(() => {
            if (this.getField('la_gondola2').getValue() === '')
                this.getField('la_gondola2').setError(false, '')
        });

        this.getField('bt_eliminar_articulo').setClick(() => {
            if (this.eliminar_articulo) {
                if (this.fila_seleccionada_informes.length > 0) {
                    this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Está seguro de eliminar el articulo del inventario físico?');
                    this.getField('confirmModalCustom').setClickDialog(this.eliminarArticuloDifReales);
                    this.getField("confirmModalCustom").setClickCancelDialog(() => {
                        this.getField('confirmModalCustom').toggle(false);
                    });
                    this.getField("confirmModalCustom").setVisibleCancel(false);
                    this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
                    this.getField('confirmModalCustom').toggle(true);
                } else {
                    this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro.', 'error');
                }
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0108)');
            }
        });


        this.getField('bt_conteo1').setClick(() => {
            if (this.conteo1) {
                this.conteo = '1';
                if (this.por_gondola === 'S') {
                    this.ocultarConteo();
                    this.getField('modal_gondola').handleClickOpen();
                } else if (this.wms === 'S') {
                    this.mostrarMensajeAdicional('Este inventario es por ubicaciones.');
                } else {
                    this.getField('info_coteo_acumula_cantidad').setValue(this.acumula);
                    this.getField('info_bodega').setValue(this.bodega);
                    this.getField('info_conteo').setValue('1');
                    this.getField('info_gondola').setVisible(false);
                    this.mostrarConteo();
                    if (this.acumula === 'S')
                        this.getField('info_conteo_articulo').setVisible(true);
                    else
                        this.getField('info_conteo_articulo').setVisible(false);
                }
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0035)');
            }

        });

        this.getField('bt_conteo2').setClick(() => {
            if (this.conteo2) {
                this.conteo = '2';
                if (this.por_gondola === 'S') {
                    this.ocultarConteo();
                    this.getField('modal_gondola').handleClickOpen();
                } else if (this.wms === 'S') {
                    this.mostrarMensajeAdicional('Este inventario es por ubicaciones.');
                } else {
                    this.getField('info_coteo_acumula_cantidad').setValue(this.acumula);
                    this.getField('info_bodega').setValue(this.bodega);
                    this.getField('info_conteo').setValue(this.conteo);
                    this.getField('info_gondola').setVisible(false);
                    this.mostrarConteo();
                    if (this.acumula === 'S')
                        this.getField('info_conteo_articulo').setVisible(true);
                    else
                        this.getField('info_conteo_articulo').setVisible(false);
                }
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0036)');
            }
        });

        this.getField('bt_conteo3').setClick(() => {
            if (this.conteo3) {
                this.conteo = '3';
                if (this.wms === 'S') {
                    this.mostrarMensajeAdicional('Este inventario es por ubicaciones.');
                } else {
                    this.getField('info_coteo_acumula_cantidad').setValue(this.acumula);
                    this.getField('info_bodega').setValue(this.bodega);
                    this.getField('info_conteo').setValue(this.conteo);
                    this.getField('info_gondola').setVisible(false);
                    this.mostrarConteo();
                    if (this.acumula === 'S')
                        this.getField('info_conteo_articulo').setVisible(true);
                    else
                        this.getField('info_conteo_articulo').setVisible(false);
                }
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0037)');
            }
        });

        this.getField('bt_cancelar_adicionales').setClick(() => {
            this.getField('modal_gondola').handleClose();
        });

        this.getField('bt_aceptar_adicionales').setClick(() => {
            if (this.getField('la_gondola').valid()) {
                this.getField('info_coteo_acumula_cantidad').setValue(this.acumula);
                this.getField('info_bodega').setValue(this.bodega);
                this.getField('info_conteo').setValue(this.conteo);
                this.getField('info_gondola').setValue(this.getField('gondola').getValue());
                this.getField('info_gondola').setVisible(true);
                this.getField('modal_gondola').handleClose();
                this.mostrarConteo();
            }
        });

        this.getField('bt_cancelar_conteo').setClick(() => {
            this.limpiarCamposConteo();
        });


        this.getField('bt_agregar_conteo').setClick(() => {
            this.validarConteoAgregar();
        });


        //funciones informes------------>

        this.getField('bt_diferencias').setClick(() => {
            this.ocultarInformes();
            if (this.lista_diferencias1_2) {
                this.informes = 'diferencias';
                if (this.tabla_por_gondola === 'S') {
                    this.getField('modal_adicionales_dif').handleClickOpen();
                } else {
                    this.aux_gondola = '';
                    this.traerTablaInformes()
                }
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0038)');
            }

        });

        this.getField('bt_imprimir_normal').setClick(() => {
            this.pantalla = false;
            if (this.informes === 'diferencias') {
                this.servicio = 'inve-abririnventario';
                this.nombre_servicio = 'diferenciaconteo_pag';
                this.nombre_archivo = 'listado_diferencias';
                this.abrirImprimir();
            } else {
                this.servicio = 'inve-abririnventario';
                this.nombre_servicio = 'diferenciasreales_pag';
                this.nombre_archivo = 'diferencias_reales';
                this.abrirImprimir();
            }
        });

        this.getField('bt_imprimir_grupos').setClick(() => {
            this.pantalla = true;
            this.servicio = 'inve-abririnventario';
            this.nombre_servicio = 'diferenciasgrupos_pag';
            this.nombre_archivo = 'diferencias_grupos';
            this.abrirImprimir();
        });

        this.getField('bt_imprimir_marcas').setClick(() => {
            this.pantalla = true;
            this.servicio = 'inve-abririnventario';
            this.nombre_servicio = 'diferenciasmarcas_pag';
            this.nombre_archivo = 'diferencias_marcas';
            this.abrirImprimir();
        });

        this.getField('bt_ver_grupos').setClick(() => {
            this.pantalla = true;
            this.servicio = 'inve-abririnventario';
            this.nombre_servicio = 'diferenciasresumengrupos_pag';
            this.nombre_archivo = 'diferencias_resumidas_por_grupo';
            this.abrirImprimir();
        });

        this.getField('bt_asentar').setClick(() => {
            if (this.puede_asentar) {
                this.accion = 'asentar';
                this.asentar();
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (IFASEN)');
            }
        });

        this.getField('bt_asentar_subgrupo').setClick(() => {
            if (this.asentar_subgrupo) {
                if (this.fila_seleccionada_informes.length > 0) {
                    this.accion = 'asentar_subgrupo';
                    this.asentarSubgrupo();
                } else {
                    this.alertGeneral.toggle(true, 'Debe elegir un registro con el subgrupo a asentar..', 'error');
                }

            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (IFASENGR)');
            }
        });

        //diferencias reales ubicación
        this.getField('bt_asentar_todo').setClick(() => {
            this.mostrar_general = false;
            if (this.puede_asentar) {
                this.accion = 'asentar_todo_ubi';
                this.previoAsentarUbi();
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (IFASEN)');
            }
        });

        this.getField('bt_asentar_ubicacion').setClick(() => {
            this.mostrar_general = true;
            if (this.puede_asentar) {
                if (this.fila_seleccionada_informes.length > 0) {
                    this.accion = 'asentar_ubicacion';
                    this.previoAsentarUbi();
                } else {
                    this.alertGeneral.toggle(true, 'Debe elegir un registro con la ubicación a asentar.', 'error');
                }
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (IFASEN)');
            }
        });

        this.getField('bt_asentar_subgrupo2').setClick(() => {
            this.mostrar_general = true;
            if (this.puede_asentar) {
                if (this.fila_seleccionada_informes.length > 0) {
                    this.accion = 'asentar_subgrupo_ubi';
                    this.previoAsentarUbi();
                } else {
                    this.alertGeneral.toggle(true, 'Debe elegir un registro con el subgrupo a asentar.', 'error');
                }
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (IFASEN)');
            }
        });

        this.getField('bt_asentar_marca').setClick(() => {
            this.mostrar_general = true;
            if (this.puede_asentar) {
                if (this.fila_seleccionada_informes.length > 0) {
                    this.accion = 'asentar_marca_ubi';
                    this.previoAsentarUbi();
                } else {
                    this.alertGeneral.toggle(true, 'Debe elegir un registro con la marca a asentar.', 'error');
                }
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (IFASEN)');
            }
        });

        this.getField('bt_recontar').setClick(() => {
            if (this.fila_seleccionada_informes.length > 0) {
                this.accion = 'asentar_marca_ubi';
                this.recontar();
            } else {
                this.alertGeneral.toggle(true, 'Debe elegir un registro a recontar.', 'error');
            }
        });

        this.getField('bt_aceptar_recontar').setClick(() => {
            if (this.getField('select_usuarios_recontar').valid()) {
                this.realizarRecontar();
            }
        });

        this.getField('bt_valorizar').setClick(() => {
            if (this.getField('select_usuarios_recontar').valid()) {
                this.soloRecalcularDiferencias();
            }
        });


        this.getField('bt_diferencias_por_articulo').setClick(() => {
            if (this.fila_seleccionada_informes.length > 0) {
                this.pantalla = true;
                this.servicio = 'inve-abririnventario';
                this.nombre_servicio = 'diferenciasarticulos_pag';
                this.nombre_archivo = 'diferencias_por_articulo';
                this.abrirImprimir();
            } else {
                this.alertGeneral.toggle(true, 'Debe elegir un registro a recontar.', 'error');
            }
        });

        this.getField('bt_diferencias_por_ubicacion').setClick(() => {
            if (this.fila_seleccionada_informes.length > 0) {
                this.pantalla = true;
                this.servicio = 'inve-abririnventario';
                this.nombre_servicio = 'diferenciasubicacion_pag';
                this.nombre_archivo = 'diferencias_por_ubicacion';
                this.abrirImprimir();
            } else {
                this.alertGeneral.toggle(true, 'Debe elegir un registro a recontar.', 'error');
            }
        });


        this.getField('bt_resumen_usuario').setClick(() => {
            if (this.fila_seleccionada_informes.length > 0) {
                this.pantalla = true;
                this.servicio = 'inve-abririnventario';
                this.nombre_servicio = 'resumenusuario_pag';
                this.nombre_archivo = 'resumen_usuario_diferencias';
                this.abrirImprimir();
            } else {
                this.alertGeneral.toggle(true, 'Debe elegir un registro a recontar.', 'error');
            }
        });







        //sobreescribir funciones de iniciar inventario para que solo valide las claves
        this.getField('bt_cancelar_iniciar').setClick(() => {
            this.getField('modal_apertura').handleClose();
        });

        this.getField('bt_aceptar_iniciar').setClick(() => {
            this.autorizarAsentar();
        });




        this.getField('bt_diferencias_reales').setClick(() => {
            this.ocultarInformes();
            if (this.diferencias_reales) {
                if (this.wms === 'S') {
                    this.informes = 'reales_ubicacion';
                    this.crearTemporalDiferenciasRealesUbi();
                } else {
                    this.informes = 'reales';
                    if (this.por_gondola === 'S')//si la propiedad esta en S pide la gandola, que igual no es requerida
                        this.getField('la_gondola2').setVisible(true);
                    this.getField('select_bodegas').setVisible(true);
                    this.getField('la_ubicacion').setVisible(false);
                    this.getField('la_seccion').setVisible(false);

                    this.getField('modal_adicionales_dif').handleClickOpen();
                }

            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0039)');
            }
        });

        this.getField('bt_cancelar_dif').setClick(() => {
            this.getField('modal_adicionales_dif').handleClose();
        });
        this.getField('bt_aceptar_dif').setClick(() => {
            if (this.informes === 'reales') {
                if (!this.getField('select_conteo').valid())
                    return;
                if (!this.getField('select_bodegas').valid() && this.getField('select_bodegas').getValue() !== '')
                    return;
                if (this.por_gondola === 'S' && this.getField('select_bodegas').getValue() !== '' && !this.getField('la_gondola2').valid())
                    return;
                this.aux_conteo = this.getField('select_conteo').getValue();
                this.aux_bodega = this.getField('select_bodegas').getValue();
                this.aux_gondola = this.getField('la_gondola2').getValue();
                this.crearTemporalDiferenciasReales();
                this.getField('modal_adicionales_dif').handleClose();
            } else if(this.informes === 'reales_gondola') {// reales por gondola
                if (this.getField('select_conteo').valid() && this.getField('la_ubicacion').valid() && this.getField('la_seccion').valid()){
                    this.aux_conteo = this.getField('select_conteo').getValue();
                    this.aux_ubicacion = this.getField('la_ubicacion').getValue();
                    this.aux_seccion = this.getField('la_seccion').getValue();
                    this.crearTemporalDiferenciasRealesGandola();
                    this.getField('modal_adicionales_dif').handleClose();
                }  
            }else{//asentar inventario
                if (this.getField('select_conteo').valid()){
                    this.aux_conteo = this.getField('select_conteo').getValue();
                    this.getField('confirmModalCustom').setTitleAndContent('Asentar', 'Está seguro de asentar el inventario?');
                    this.getField('confirmModalCustom').setClickDialog(this.asentarInventario);
                    this.getField("confirmModalCustom").setClickCancelDialog(() => {
                        this.getField('confirmModalCustom').toggle(false);
                    });
                    this.getField("confirmModalCustom").setVisibleCancel(false);
                    this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
                    this.getField('confirmModalCustom').toggle(true);
                }
            }
        });

        this.getField('bt_diferencias_reales_gondola').setClick(() => {
            this.ocultarInformes();
            if (this.diferencias_reales_gandola) {
                this.informes = 'reales_gondola';
                this.getField('la_gondola2').setVisible(false);
                this.getField('select_bodegas').setVisible(false);
                this.getField('la_ubicacion').setVisible(true);
                this.getField('la_seccion').setVisible(true);
                this.getField('modal_adicionales_dif').handleClickOpen();
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0040)');
            }
        });




        //codigo articulo validaciones prioridad barras
        this.getField("codigo_articulo_aux").setOnChange(() => {
            if (this.getField('codigo_articulo_aux').getValue() !== '' && this.prioridad_barras === 'S' && this.cambiar_prioridad !== false) {
                this.validarCodigo();
            } else if (this.prioridad_barras !== 'S') {
                //aquí no tiene prioridad entonces trae directamente el artículo
                if (this.getField('codigo_articulo_aux').getValue() !== '' && this.respuesta_completa === true && this.datos_articulo_aux.length <= 1) {
                    this.sucessTraerArticulo2(this.datos_articulo_aux);
                } else if (this.datos_articulo_aux.length > 1 && this.getField("codigo_articulo_aux").getValue() === this.getField("codigo_articulo_conteo").getValue()) {
                    this.sucessTraerArticulo2(this.datos_articulo_aux);
                }
            }
        });

        this.getField("codigo_articulo_conteo").setOnChange(() => {
            this.respuesta_completa = false;
            this.getField('nombre_articulo_conteo').setError(false, '');
            this.getField('info_conteo_articulo').setError(false, '');
            this.getField('cantidad_conteo').setError(false, '');

            this.getField('nombre_articulo_conteo').setValue('');
            this.getField('info_conteo_articulo').setValue('');
            this.getField('cantidad_conteo').setValue('');
        });

        this.getField("codigo_articulo_conteo").setCustomSuccess((props) => {
            this.datos_articulo_aux = props;
            this.respuesta_completa = true;
            if (this.prioridad_barras !== 'S') {
                //para forzar a consumir de nuevo el onchange
                this.getField("codigo_articulo_aux").setValue('cod_aux');
            }
            if (props.length <= 1 && this.operacion_seleccionada !== 'F9') {
                if (this.prioridad_barras === 'S') {
                    this.cambiar_prioridad = false;
                    this.validarCodigo();
                } else {
                    this.cambiar_prioridad = true;
                }
            } else {
                this.cambiar_prioridad = true;
            }
        });

        //sobreescrivir keyups
        this.getField('codigo_articulo_conteo').setKeyUp((e) => { this.changeKeyUpCustom(e) });


        //especiales-------------------------->
        this.getField('bt_reiniciar_conteo').setClick(() => {
            if (this.reiniciar_conteo) {
                this.getField('confirmModalCustom').setTitleAndContent('Reiniciar conteo', 'Está seguro de reiniciar los conteos?');
                this.getField('confirmModalCustom').setClickDialog(this.reiniciarConteo);
                this.getField("confirmModalCustom").setClickCancelDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
                this.getField('confirmModalCustom').toggle(true);
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0041)');
            }
        });

        this.getField('bt_actualizar_articulos').setClick(() => {
            if (this.actualizar_articulos) {
                this.getField('confirmModalCustom').setTitleAndContent('Actualizar artículos', 'Está seguro de actualizar los artículos?');
                this.getField('confirmModalCustom').setClickDialog(this.actualizarArticulos);
                this.getField("confirmModalCustom").setClickCancelDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
                this.getField('confirmModalCustom').toggle(true);
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0042)');
            }
        });

        this.getField('bt_asentar_inventario').setClick(() => {
            if (this.asentar_inventario) {
                if(this.wms==='S'){
                    this.mostrarMensajeAdicional('Este inventario es por ubicaciones.');
                }else{
                    this.getField('la_gondola2').setVisible(false);
                    this.getField('la_ubicacion').setVisible(false);
                    this.getField('la_seccion').setVisible(false);
                    this.getField('select_bodegas').setVisible(false);
                    this.getField('modal_adicionales_dif').handleClickOpen();
                }
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0043)');
            }
        });

        this.getField('bt_bloquear_inventario').setClick(() => {
            if (this.bloquear_inventario) {
                this.getField('confirmModalCustom').setTitleAndContent('Bloquear inventario', '¿Está seguro de bloquear el Inventario Físico?. Nadie podrá entrar, grabar conteo ni generar informes hasta que no sea iniciado de nuevo.');
                this.getField('confirmModalCustom').setClickDialog(this.bloquearInventario);
                this.getField("confirmModalCustom").setClickCancelDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
                this.getField('confirmModalCustom').toggle(true);
            } else {
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0106)');
            }
        });



    }

    bloquearInventario() {
        let datos = {
            datos: {
                bodega:this.bodega,
            }
        }
        this.mostrarMensajeGuardando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: '6_bloquarinventario', operacion_tipo: 'modificar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: datos,
                success: this.successBloquearInventario,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successBloquearInventario(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.mostrarMensajeAdicional('Inventario bloqueado con éxito.');
            this.getField('TabJaivana_263').setTabNumber(4);
            //se sobreescribe para que no pueda volver a ponerse en los otras tabs
            this.getField("TabJaivana_263").setClickTab(() => {
                this.getField('TabJaivana_263').setTabNumber(4);
            });
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }


    asentarInventario() {//asentar inventario por menu principal (especiales)
        this.getField('modal_adicionales_dif').handleClose();
        let datos = {
            datos: {
                campo_costo: this.campo_costo,
                bodega: this.bodega,
                conteo: this.aux_conteo,
                tabla: this.tabla,
                sucursal_ingreso: this.sucursal_ingreso,
            }
        }
        this.mostrarMensajeGuardando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'asentarinventario', operacion_tipo: 'modificar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: datos,
                success: this.successAsentarInventario,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successAsentarInventario(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.input !== undefined) {
                this.getField('confirmModalCustom').setTitleAndContent('Asentar', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => { //selecciono que si a guardar historico
                    this.getField('confirmModalCustom').toggle(false);
                    let datos = {
                        datos: {
                            campo_costo: this.campo_costo,
                            bodega: this.bodega,
                            conteo: this.aux_conteo,
                            tabla: this.tabla,
                            sucursal_ingreso: this.sucursal_ingreso,
                            input:'1',
                        }
                    }
                    this.mostrarMensajeGuardando();
                    this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'asentarinventario', operacion_tipo: 'modificar' };
                    this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method: 'PUT',
                            body: datos,
                            success: this.successAsentarInventario,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                });
                this.getField("confirmModalCustom").setClickCancelDialog(() => { //selecciono que no a guardar historico
                    this.getField('confirmModalCustom').toggle(false);
                    let datos = {
                        datos: {
                            campo_costo: this.campo_costo,
                            bodega: this.bodega,
                            conteo: this.aux_conteo,
                            tabla: this.tabla,
                            sucursal_ingreso: this.sucursal_ingreso,
                            input:'0',
                        }
                    }
                    this.mostrarMensajeGuardando();
                    this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'asentarinventario', operacion_tipo: 'modificar' };
                    this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method: 'PUT',
                            body: datos,
                            success: this.successAsentarInventario,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField("confirmModalCustom").setButtonConfirm('SI');
                this.getField('confirmModalCustom').toggle(true);
            } else if (data.data.mensaje_mostrar !== undefined) {
                if (data.data.articulos !== undefined) {

                    if (this.accion === 'asentar_subgrupo')
                        this.getField('modal_ver_grupos').setLabel('Artículos con costo cero. Subgrupo ' + this.fila_seleccionada_informes[0].subgrupo);
                    else
                        this.getField('modal_ver_grupos').setLabel('Artículos con costo cero.');
                    this.getField('modal_ver_grupos').handleClickOpen();
                    this.gridOptionsComponentesItems['rowData'] = data.data.articulos;
                    this.getField('rejilla_saldos').toggle(false);

                    let configCell = new Map();
                    configCell.set('conteo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: { textAlign: "right" }, width: 110 });

                    this.getField('rejilla_saldos').initData(this.gridOptionsComponentesItems, configCell);
                    this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                } else {
                    this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                }
            } else {
                this.getField('modal_apertura').handleClose();
                this.mostrarMensajeAdicional('Inventario Asentado.');
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    actualizarArticulos() {
        let datos = {
            datos: {
                tabla: this.tabla,
                wms: this.wms,
                campo_costo: this.campo_costo,
            }
        }
        this.mostrarMensajeGuardando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'actualizar_articulos', operacion_tipo: 'modificar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: datos,
                success: this.successActualizarArticulos,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successActualizarArticulos(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.mostrarMensajeAdicional('Artículos actualizados.');
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    reiniciarConteo() {
        let datos = {
            datos: {
                tabla: this.tabla,
                wms: this.wms,
                campo_costo: this.campo_costo,
                bodega: this.bodega,
            }
        }
        this.mostrarMensajeGuardando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'reiniciar_conteo', operacion_tipo: 'crear' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successReiniciarConteo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successReiniciarConteo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.mostrarMensajeAdicional('Conteo Reiniciado.');
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    crearTemporalDiferenciasRealesGandola() {
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                select_conteo: this.aux_conteo,
                la_seccion: this.aux_seccion,
                la_ubicacion: this.aux_ubicacion,
                campo_costo: this.campo_costo,
                tabla: this.tabla,
                bodega: this.bodega,

            }
        }
        this.mostrarMensajeGenerando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'creartemporaldifrealesxgondola', operacion_tipo: 'crear' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successCrearTemporalDiferenciasRealesGandola,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successCrearTemporalDiferenciasRealesGandola(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.conteo = this.aux_conteo;
            this.informes = 'reales_gondola';
            this.traerTablaInformes()
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    realizarRecontar() {
        //como tal solo se enviará un registro, ya que actualmente no se pueden seleccionar varios
        //por tanto puedo enviar los datos de la fila seleccionada de informes
        let datos = {
            datos: {
                tabla: this.tabla + '_ubicaciones',
                ubicacion: this.fila_seleccionada_informes[0].ubicacion,
                codigo_articulo_aux: this.fila_seleccionada_informes[0].codigo,
                select_usuarios_recontar: this.getField('select_usuarios_recontar').getValue(),
            }
        }
        this.mostrarMensajeGuardando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'recontar', operacion_tipo: 'modificar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT', //put 
                body: datos,
                success: this.successrealizarRecontar,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    successrealizarRecontar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('modal_recontar').handleClose();
            this.alertGeneral.toggle(true, 'Se envío a recontar con exito!', 'success');
            this.soloRecalcularDiferencias();
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }


    recontar() {
        let array_datos = this.gridOptionsInformes['rowData'];
        let datos_nuevos = []
        this.getField('modal_recontar').handleClickOpen();
        let row = {};

        array_datos.forEach((element) => {
            row = {
                codigo: element.codigo,
                nombre: element.nombre,
                ubicacion: element.ubicacion,
                usuario: element.usuario,
            }
            array_datos.push(row);
        });

        this.gridOptionsComponentesRecontar['rowData'] = datos_nuevos;
        this.getField('rejilla_normal').toggle(false);
        let configCell = new Map();
        this.getField('rejilla_normal').initData(this.gridOptionsComponentesRecontar, configCell);
        this.traerUsuarios();//llenar select
    }

    soloRecalcularDiferencias() {
        let datos = {
            datos: {
                tabla: this.tabla + '_ubicaciones',
            }
        }
        this.mostrarMensajeGuardando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'recalculardiferencias', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET', //put 
                body: datos,
                success: this.successSoloRecalcularDiferencias,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    successSoloRecalcularDiferencias(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            //this.getField('modal_recontar').handleClose();
            this.traerTablaInformes();
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    crearTemporalDiferenciasRealesUbi() {
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                campo_costo: this.campo_costo,
                tabla: this.tabla + '_ubicaciones',
                bodega: this.bodega,
            }
        }
        this.mostrarMensajeGenerando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'creartemporaldifrealesubi', operacion_tipo: 'crear' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successCrearTemporalDiferenciasRealesUbi,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successCrearTemporalDiferenciasRealesUbi(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.informes = 'reales_ubicacion';
            this.traerTablaInformes()
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    previoAsentarUbi() {
        let datos = {
            datos: {
                tabla: this.tabla + '_ubicaciones',
            }
        }
        if (this.accion === 'asentar_ubicacion')
            datos.datos.ubicacion = this.fila_seleccionada_informes[0].ubicacion;
        else if (this.accion === 'asentar_subgrupo_ubi')
            datos.datos.subgrupo = this.fila_seleccionada_informes[0].subgrupo;
        else if (this.accion === 'asentar_marca_ubi')
            datos.datos.marca = this.fila_seleccionada_informes[0].marca;
        this.mostrarMensajeGuardando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'recalculardiferencias', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successprevioAsentarUbi,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    successprevioAsentarUbi(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (this.mostrar_general && this.data.data.length > 0) {
                if (this.accion === 'asentar_ubicacion')
                    this.getField('modal_normal').setLabel('Asentar Ubicación ' + this.fila_seleccionada_informes[0].ubicacion);
                else if (this.accion === 'asentar_subgrupo_ubi')
                    this.getField('modal_normal').setLabel('Asentar Subgrupo ' + this.fila_seleccionada_informes[0].subgrupo);
                else if (this.accion === 'asentar_marca_ubi')
                    this.getField('modal_normal').setLabel('Asentar Marca ' + this.fila_seleccionada_informes[0].marca);
                this.getField('modal_normal').handleClickOpen();

                this.gridOptionsComponentesItems['rowData'] = data.data.articulos;
                this.getField('rejilla_normal').toggle(false);
                let configCell = new Map();
                configCell.set('conteo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: { textAlign: "right" }, width: 110 });
                configCell.set('saldo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: { textAlign: "right" }, width: 110 });
                configCell.set('total', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.total) }, cellStyle: { textAlign: "right" }, width: 110 });

                this.getField('rejilla_normal').initData(this.gridOptionsComponentesItems, configCell);
            }
            this.asentarGeneralUbi();
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    asentarGeneralUbi() {
        if (this.gridOptionsInformes['rowData'].length > 0) {
            let datos = {
                datos: {
                    tabla: this.tabla + '_ubicaciones',
                    campo_costo: this.campo_costo,
                    bodega: this.bodega,
                    conteo: this.conteo,
                    sucursal_ingreso: this.sucursal_ingreso,
                }
            }
            if (this.accion === 'asentar_ubicacion')
                datos.datos.ubicacion = this.fila_seleccionada_informes[0].ubicacion;
            else if (this.accion === 'asentar_subgrupo_ubi')
                datos.datos.subgrupo = this.fila_seleccionada_informes[0].subgrupo;
            else if (this.accion === 'asentar_marca_ubi')
                datos.datos.marca = this.fila_seleccionada_informes[0].marca;

            this.mostrarMensajeGuardando();
            this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'asentargeneralubicaciones', operacion_tipo: 'crear' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.successAsentarGeneralUbi,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        } else {
            this.mostrarMensajeAdicional('No hay datos para asentar.');
        }

    }

    successAsentarGeneralUbi(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.input !== undefined) {
                this.getField('confirmModalCustom').setTitleAndContent('Asentar', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                    this.inicioValidaciones();
                });
                this.getField("confirmModalCustom").setClickCancelDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
                this.getField('confirmModalCustom').toggle(true);
            } else if (data.data.mensaje_mostrar !== undefined) {
                if (data.data.articulos !== undefined) {

                    if (this.accion === 'asentar_ubicacion')
                        this.getField('modal_ver_grupos').setLabel('Artículos con costo cero. Ubicación ' + this.fila_seleccionada_informes[0].ubicacion);
                    else if (this.accion === 'asentar_subgrupo_ubi')
                        this.getField('modal_ver_grupos').setLabel('Artículos con costo cero. Subgrupo ' + this.fila_seleccionada_informes[0].subgrupo);
                    else if (this.accion === 'asentar_marca_ubi')
                        this.getField('modal_ver_grupos').setLabel('Artículos con costo cero. Marca ' + this.fila_seleccionada_informes[0].marca);
                    else
                        this.getField('modal_ver_grupos').setLabel('Artículos con costo cero.');
                    this.getField('modal_ver_grupos').handleClickOpen();
                    this.gridOptionsComponentesItems['rowData'] = data.data.articulos;
                    this.getField('rejilla_saldos').toggle(false);

                    let configCell = new Map();
                    configCell.set('conteo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: { textAlign: "right" }, width: 110 });

                    this.getField('rejilla_saldos').initData(this.gridOptionsComponentesItems, configCell);
                    this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                } else {
                    this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                    this.ocultarInformes();

                    //al asentar todo sale del formulario
                    let bloquear =false;
                    if(this.accion === 'asentar_ubicacion' || this.accion === 'asentar_subgrupo_ubi' || this.accion === 'asentar_marca_ubi'){
                        if(data.data.restante !== undefined && data.data.restante<=0){
                            bloquear=true;
                        }
                    }else{
                        bloquear=true;
                    }
                    if(bloquear){
                        this.getField('TabJaivana_263').setTabNumber(4);
                        //se sobreescribe para que no pueda volver a ponerse en los otras tabs
                        this.getField("TabJaivana_263").setClickTab(() => {
                            this.getField('TabJaivana_263').setTabNumber(4);
                        });
                    }else{
                        this.ocultarInformes();//para que oculte el informe y tenga que volver a generar los datos
                    }
                }

            } else {
                this.getField('modal_apertura').handleClose();
                this.mostrarMensajeAdicional('Datos asentados con éxito. ' + (data.data.mensaje_ajuste !== undefined ? data.data.mensaje_ajuste : ''));
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }




    asentarSubgrupo() {
        if (this.gridOptionsInformes['rowData'].length > 0) {
            let datos = {
                datos: {
                    campo_costo: this.campo_costo,
                    bodega: this.bodega,
                    conteo: this.conteo,
                    tabla: this.tabla,
                    sucursal_ingreso: this.sucursal_ingreso,
                    subgrupo: this.fila_seleccionada_informes[0].subgrupo,
                }
            }
            this.mostrarMensajeGuardando();
            this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'asentarsugbrupo', operacion_tipo: 'crear' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.successAsentar,//puedo apuntarla al mismo
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        } else {
            this.mostrarMensajeAdicional('No hay datos para asentar.');
        }

    }

    asentar() {
        if (this.gridOptionsInformes['rowData'].length > 0) {
            let datos = {
                datos: {
                    campo_costo: this.campo_costo,
                    bodega: this.bodega,
                    conteo: this.conteo,
                    tabla: this.tabla,
                    sucursal_ingreso: this.sucursal_ingreso,
                }
            }
            this.mostrarMensajeGuardando();
            this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'asentar', operacion_tipo: 'crear' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.successAsentar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        } else {
            this.mostrarMensajeAdicional('No hay datos para asentar.');
        }

    }

    successAsentar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.input !== undefined) {
                this.getField('confirmModalCustom').setTitleAndContent('Asentar', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                    this.inicioValidaciones();
                });
                this.getField("confirmModalCustom").setClickCancelDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
                this.getField('confirmModalCustom').toggle(true);
            } else if (data.data.mensaje_mostrar !== undefined) {
                if (data.data.articulos !== undefined) {

                    if (this.accion === 'asentar_subgrupo')
                        this.getField('modal_ver_grupos').setLabel('Artículos con costo cero. Subgrupo ' + this.fila_seleccionada_informes[0].subgrupo);
                    else
                        this.getField('modal_ver_grupos').setLabel('Artículos con costo cero.');
                    this.getField('modal_ver_grupos').handleClickOpen();
                    this.gridOptionsComponentesItems['rowData'] = data.data.articulos;
                    this.getField('rejilla_saldos').toggle(false);

                    let configCell = new Map();
                    configCell.set('conteo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: { textAlign: "right" }, width: 110 });

                    this.getField('rejilla_saldos').initData(this.gridOptionsComponentesItems, configCell);
                    this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                } else {
                    this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                    this.ocultarInformes();
                    if (data.data.restante !== undefined && data.data.restante > 0) {//ahí más datos a asentar, entonces volver a crear la temporal
                        //validar-->
                        //this.crearTemporalDiferenciasReales();
                        this.traerTablaInformes()
                    }
                }

            } else {
                this.getField('modal_apertura').handleClose();
                this.mostrarMensajeAdicional('Datos asentados con éxito. ' + (data.data.mensaje_ajuste !== undefined ? data.data.mensaje_ajuste : ''));
                if(data.data.errores!==undefined && data.data.errores.length>0){
                    let respuesta = Object.values(data.data.errores);
                    this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
                }
                //al asentar todo sale del formulario
                let bloquear =false;
                if(this.accion === 'asentar_subgrupo'){
                    if(data.data.restante !== undefined && data.data.restante<=0){
                        bloquear=true;
                    }
                }else{
                    bloquear=true;
                }
                if(bloquear){
                    this.getField('TabJaivana_263').setTabNumber(4);
                    //se sobreescribe para que no pueda volver a ponerse en los otras tabs
                    this.getField("TabJaivana_263").setClickTab(() => {
                        this.getField('TabJaivana_263').setTabNumber(4);
                    });
                }else{
                    this.ocultarInformes();//para que oculte el informe y tenga que volver a generar los datos
                }
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    autorizarAsentar() {
        if (this.getField('info_iniciar_detalle').valid() && this.getField('info_iniciar_administrador').valid() &&
            this.getField('info_iniciar_auditoria').valid() &&
            this.getField('info_iniciar_detalle').valid() &&
            this.getField('clave_admin').valid() &&
            this.getField('clave_auditoria').valid()) {
            let datos = {
                datos: {
                    admin: this.getField('info_iniciar_administrador').getValue(),
                    audit: this.getField('info_iniciar_auditoria').getValue(),
                    clave_admin: this.getField('clave_admin').getValue(),
                    clave_auditoria: this.getField('clave_auditoria').getValue(),
                    info_iniciar_detalle: this.getField('info_iniciar_detalle').getValue(),
                    id_inventario: this.fila_seleccionada[0].id,
                }
            }
            this.mostrarMensajeGuardando();
            this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'iniciarinventario', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successautorizarAsentar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });

        } else {
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }

    }

    successautorizarAsentar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.mensaje_mostrar !== undefined) {
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            } else {
                this.alertGeneral.toggle(true, 'Acción realizada con éxito.', 'success');
                if (this.accion === 'asentar') {
                    let datos = {
                        datos: {
                            campo_costo: this.campo_costo,
                            bodega: this.bodega,
                            conteo: this.conteo,
                            tabla: this.tabla,
                            sucursal_ingreso: this.sucursal_ingreso,
                            input: '1',       //confirmacion
                            info_iniciar_detalle: this.getField('info_iniciar_detalle').getValue(),
                        }
                    }
                    this.mostrarMensajeGuardando();
                    this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'asentar', operacion_tipo: 'crear' };
                    this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method: 'POST',
                            body: datos,
                            success: this.successAsentar,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                } else if (this.accion === 'asentar_subgrupo') {
                    let datos = {
                        datos: {
                            campo_costo: this.campo_costo,
                            bodega: this.bodega,
                            conteo: this.conteo,
                            tabla: this.tabla,
                            sucursal_ingreso: this.sucursal_ingreso,
                            subgrupo: this.fila_seleccionada_informes[0].subgrupo,
                            input: '1',       //confirmacion
                            info_iniciar_detalle: this.getField('info_iniciar_detalle').getValue(),
                        }
                    }
                    this.mostrarMensajeGuardando();
                    this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'asentarsugbrupo', operacion_tipo: 'crear' };
                    this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method: 'POST',
                            body: datos,
                            success: this.successAsentar,//puedo apuntarla al mismo
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                } else if (this.accion === 'asentar_todo_ubi') {//ubicaciones

                    let datos = {
                        datos: {
                            tabla: this.tabla + '_ubicaciones',
                            campo_costo: this.campo_costo,
                            bodega: this.bodega,
                            conteo: this.conteo,
                            sucursal_ingreso: this.sucursal_ingreso,
                            input: '1',       //confirmacion
                            info_iniciar_detalle: this.getField('info_iniciar_detalle').getValue(),
                        }
                    }
                    if (this.accion === 'asentar_ubicacion')
                        datos.datos.ubicacion = this.fila_seleccionada_informes[0].ubicacion;
                    else if (this.accion === 'asentar_subgrupo_ubi')
                        datos.datos.subgrupo = this.fila_seleccionada_informes[0].subgrupo;
                    else if (this.accion === 'asentar_marca_ubi')
                        datos.datos.marca = this.fila_seleccionada_informes[0].marca;

                    this.mostrarMensajeGuardando();
                    this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'asentargeneralubicaciones', operacion_tipo: 'crear' };
                    this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method: 'POST',
                            body: datos,
                            success: this.successAsentarGeneralUbi,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                }else{
                    this.traerInventarios();
                }
                this.getField('modal_apertura').handleClose();
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    eliminarArticuloDifReales() {
        this.mostrarMensajeGuardando();
        let datos = {
            datos: {
                codigo_articulo_aux: this.fila_seleccionada_informes[0].codigo,
                tabla: this.tabla + (this.informes === 'reales_ubicacion' ? '_ubicaciones' : ''), //para ver si eliminar en normal o en ubicaciones
                bodega: this.bodega
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'eliminararticulodiferenciasreales', operacion_tipo: 'eliminar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: datos,
                success: this.successeliminarArticuloDifReales,
                error: this.error_,
                general: this.generalFormatPmv
            });
    }

    successeliminarArticuloDifReales(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.mensaje_mostrar !== undefined) {
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            } else {
                this.ocultarInformes();
                this.alertGeneral.toggle(true, 'El artículo se elimino con exito!', 'success');
                this.traerTablaInformes();
            }
        }
        else if (data.estado_p === 404) {
            this.mostrarMensajeNoHayDatos();
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }



    ocultarInformes() {
        this.fila_seleccionada_informes = [];

        this.getField('rejilla_informe').toggle(false);
        this.getField('costo_informe').setVisible(false);
        this.getField('bt_eliminar_articulo').setVisible(false);
        this.getField('bt_imprimir_normal').setVisible(false);
        this.getField('bt_imprimir_grupos').setVisible(false);
        this.getField('bt_imprimir_marcas').setVisible(false);
        this.getField('bt_ver_grupos').setVisible(false);
        this.getField('bt_asentar').setVisible(false);
        this.getField('bt_asentar_subgrupo').setVisible(false);

        this.getField('bt_valorizar').setVisible(false);
        this.getField('bt_asentar_todo').setVisible(false);
        this.getField('bt_asentar_ubicacion').setVisible(false);
        this.getField('bt_asentar_subgrupo2').setVisible(false);
        this.getField('bt_asentar_marca').setVisible(false);
        this.getField('bt_recontar').setVisible(false);
        this.getField('bt_diferencias_por_articulo').setVisible(false);
        this.getField('bt_diferencias_por_ubicacion').setVisible(false);
        this.getField('bt_resumen_usuario').setVisible(false);
        this.getField('titulo_informe').setVisible(false);
    }

    onSelectionChangedInformes() {
        this.fila_seleccionada_informes = this.gridOptionsInformes.api.getSelectedRows();
    }

    onSelectionChangedNada() {

    }

    crearTemporalDiferenciasReales() {
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                select_conteo: this.aux_conteo,
                select_bodegas: this.aux_bodega,
                la_gondola2: this.aux_gondola,
                campo_costo: this.campo_costo,
                tabla: this.tabla,
                bodega: this.bodega,
            }
        }
        this.mostrarMensajeGenerando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'creartemporaldifreales', operacion_tipo: 'crear' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successcrearTemporalDiferenciasReales,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successcrearTemporalDiferenciasReales(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.conteo = this.aux_conteo;
            this.informes = 'reales';
            this.traerTablaInformes()
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    traerTablaInformes() {
        let op = ''
        let datos = {
            datos: {
                bodega: this.bodega,
                sucursal_ingreso: this.sucursal_ingreso,
                operacion: 'pantalla'
            }
        };
        if (this.informes === 'diferencias') {
            op = 'diferenciaconteo';
            datos = {
                datos: {
                    tabla: this.tabla,
                    bodega: this.bodega,
                    sucursal_ingreso: this.sucursal_ingreso,
                    operacion: 'pantalla'
                }
            };
            if (this.aux_gondola.trim() !== '')
                datos.datos.la_gondola2 = this.aux_gondola;
        } else if (this.informes === 'reales' || this.informes === 'reales_gondola') {
            op = 'diferenciasreales';
        } else if (this.informes === 'reales_ubicacion') {
            op = 'diferenciasrealesubi';
        }
        this.mostrarMensajeGenerando();
        this.getField("rejilla_informe").setTipoServicioOperacion("inve-abririnventario-" + op);
        this.getField("rejilla_informe").sendRequest(this.sucesstraerTablaInformes, datos);
    }

    sucesstraerTablaInformes(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            let configCell = new Map();
            if(this.informes !== 'diferencias')
                configCell.set('conteo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: { textAlign: "right" } });
            configCell.set('saldo_bodega', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.saldo_bodega) }, cellStyle: { textAlign: "right" } });
            configCell.set('diferencia', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.diferencia) }, cellStyle: { textAlign: "right" } });
            configCell.set('costo_total', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.costo_total) }, cellStyle: { textAlign: "right" } });



            this.gridOptionsInformes['rowData'] = data.data.datos_items;//los datos del servicio se cargan en la tabla por defecto del crud
            this.getField('rejilla_informe').initData(this.gridOptionsInformes, configCell);
            this.getField('titulo_informe').setVisible(true);
            if (this.informes === 'diferencias') {
                this.getField('titulo_informe').setValue("DIFERENCIAS ENTRE CONTEOS - BODEGA " + this.bodega);

                this.getField('bt_imprimir_normal').setVisible(true);
            } else if (this.informes === 'reales') {
                this.getField('titulo_informe').setValue("DIFERENCIAS REALES - BODEGA " + this.bodega);

                this.getField('bt_eliminar_articulo').setVisible(true);
                this.getField('costo_informe').setVisible(true);


                this.getField('bt_imprimir_normal').setVisible(true);
                this.getField('bt_imprimir_grupos').setVisible(true);
                this.getField('bt_imprimir_marcas').setVisible(true);
                this.getField('bt_ver_grupos').setVisible(true);
                this.getField('bt_asentar').setVisible(true);
                this.getField('bt_asentar_subgrupo').setVisible(true);
                this.getField('costo_informe').setValue(data.data.datos_lista.total);
            } else if (this.informes === 'reales_ubicacion') {
                this.getField('titulo_informe').setValue("DIFERENCIAS REALES POR UBICACIÓN - BODEGA " + this.bodega);

                this.getField('bt_eliminar_articulo').setVisible(true);
                this.getField('costo_informe').setVisible(true);

                this.getField('bt_asentar_todo').setVisible(true);
                this.getField('bt_asentar_ubicacion').setVisible(true);
                this.getField('bt_asentar_subgrupo2').setVisible(true);
                this.getField('bt_asentar_marca').setVisible(true);
                this.getField('bt_recontar').setVisible(true);
                this.getField('bt_diferencias_por_articulo').setVisible(true);
                this.getField('bt_diferencias_por_ubicacion').setVisible(true);
                this.getField('bt_resumen_usuario').setVisible(true);

                this.getField('costo_informe').setValue(data.data.datos_lista.total);
            } else if (this.informes === 'reales_gondola') {
                this.getField('titulo_informe').setValue("DIFERENCIAS REALES - BODEGA " + this.bodega + "  UBICACION: " + this.aux_ubicacion + " Seccion " + this.aux_seccion);

                this.getField('bt_eliminar_articulo').setVisible(true);
                this.getField('costo_informe').setVisible(true);


                this.getField('bt_imprimir_normal').setVisible(true);
                this.getField('bt_imprimir_grupos').setVisible(true);
                this.getField('bt_imprimir_marcas').setVisible(true);
                this.getField('bt_ver_grupos').setVisible(true);
                this.getField('bt_asentar').setVisible(true);
                this.getField('bt_asentar_subgrupo').setVisible(true);
                this.getField('costo_informe').setValue(data.data.datos_lista.total);
            }


        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }


    validarConteoAgregar() {
        if (!this.getField('codigo_articulo_conteo').valid())
            return;
        if (!this.getField('nombre_articulo_conteo').valid())
            return;
        if (!this.getField('cantidad_conteo').valid())
            return;
        if (this.por_gondola !== 'S' && this.fila_seleccionada[0].estado !== 'A' && this.fila_seleccionada[0].estado !== 'C' && this.fila_seleccionada[0].estado !== 'c')
            this.mostrarMensajeAdicional('El inventario no esta abierto, no se pueden hacer conteos.');
        if (this.cantidad_permitida === '') {
            this.mostrarMensajeAdicional('Falta configurar cantidad permitida.');
            return;
        }
        try {
            if (Number(this.getField('cantidad_conteo').getValue()) > Number(this.cantidad_permitida)) {
                this.mostrarMensajeAdicional('Cantidad no permitida. La cantidad máxima permitida (' + this.cantidad_permitida + ')');
                return;
            }
        } catch (error) {
            this.mostrarMensajeAdicional('Ocurrio un erro comparando la cantidad con la cantidad permitida.');
            return;
        }
        try {
            if (this.por_gondola === 'S' && this.acumula !== 'S' && (Number(this.getField('cantidad_conteo').getValue() + Number(this.getField('info_conteo_articulo').getValue()))) < 0) {
                this.mostrarMensajeAdicional('Cantidad no permitida!. Genera negativo en el conteo.');
                return;
            }
        } catch (error) {
            this.mostrarMensajeAdicional('Ocurrio un erro comparando la cantidad actual con la cantidad a agregar.');
            return;
        }

        //pasamos a grabar--->

        let datos = {
            datos: {
                tabla: this.tabla,
                info_coteo_acumula_cantidad: this.getField('info_coteo_acumula_cantidad').getValue(),
                info_conteo: this.getField('info_conteo').getValue(),
                por_gondola: this.por_gondola,
                info_gondola: this.getField('info_gondola').getValue(),
                bodega: this.bodega,
                codigo_articulo_conteo: this.getField('codigo_articulo_conteo').getValue(),
                conteo: 'bodega_' + this.bodega + "_c" + this.conteo,
                cantidad_conteo: this.getField('cantidad_conteo').getValue(),
            }
        }
        if (this.por_gondola)
            datos.datos.info_gondola = this.getField('info_gondola').getValue();
        this.mostrarMensajeGuardando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'agregarconteo', operacion_tipo: 'crear' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successAgregarConteo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    successAgregarConteo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.mensaje_mostrar !== undefined) {
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            } else {
                this.mostrarMensajeAdicional('Guardado con éxito.');
                this.getField('codigo_articulo_conteo').setValue('');
                this.getField('nombre_articulo_conteo').setValue('');
                this.getField('info_conteo_articulo').setValue('');
                this.getField('cantidad_conteo').setValue('');
            }

        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    ocultarConteo() {
        this.getField('info_coteo_acumula_cantidad').setVisible(false);
        this.getField('info_bodega').setVisible(false);
        this.getField('info_conteo').setVisible(false);
        this.getField('info_gondola').setVisible(false);
        this.getField('codigo_articulo_conteo').setVisible(false);
        this.getField('nombre_articulo_conteo').setVisible(false);
        this.getField('info_conteo_articulo').setVisible(false);
        this.getField('cantidad_conteo').setVisible(false);
        this.getField('bt_agregar_conteo').setVisible(false);
        this.getField('bt_cancelar_conteo').setVisible(false);
    }

    mostrarConteo() {
        this.getField('info_coteo_acumula_cantidad').setVisible(true);
        this.getField('info_bodega').setVisible(true);
        this.getField('info_conteo').setVisible(true);
        //this.getField('info_gondola').setVisible(true);
        this.getField('codigo_articulo_conteo').setVisible(true);
        this.getField('nombre_articulo_conteo').setVisible(true);
        this.getField('info_conteo_articulo').setVisible(true);
        this.getField('cantidad_conteo').setVisible(true);
        this.getField('bt_agregar_conteo').setVisible(true);
        this.getField('bt_cancelar_conteo').setVisible(true);
        this.limpiarCamposConteo();
    }

    validarCodigo() {
        if (this.getField("codigo_articulo_conteo").valid()) {
            let datos = {
                datos: {
                    codigo_articulo_conteo: this.getField("codigo_articulo_conteo").getValue(),
                    sucursal_ingreso: this.sucursal_ingreso,
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'codigoauxiliar', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.sucessValidarCodigo,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        }
    }

    sucessValidarCodigo(data) {
        if (data.estado_p === 200) {
            if (data.data.alterno) {
                this.mostrarMensajeAdicional('El código ' + this.getField('codigo_articulo_conteo').getValue() + ' es alterno!');
                this.getField('codigo_articulo_conteo').setValue('');
                this.getField('nombre_articulo_conteo').setValue('');
                this.getField('info_conteo_articulo').setValue('');
                this.getField('cantidad_conteo').setValue('');
            } else {
                this.getField('codigo_articulo_conteo').setValue(data.data.codigo);
                this.traerInfoArticulo();
            }

        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos sobre el artículo.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    traerConteo() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                codigo_articulo_conteo: this.getField('codigo_articulo_conteo').getValue(),
                value: 'bodega_' + this.bodega + "_c" + this.conteo,
                tabla: this.tabla,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: '1_conteo_actual', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerConteo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerConteo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (this.acumula)
                this.getField('info_conteo_articulo').setValue(0);
            else
                this.getField('info_conteo_articulo').setValue(data.data[0].valor);

            this.getField('cantidad_conteo').setValue(data.data[0].valor);
        } else if (data.estado_p === 404) {
            this.alertGeneral.toggle(true, 'El artículo '+this.getField('codigo_articulo_conteo').getValue()+' no existe en la tabla de conteo.', 'error');
            this.getField('codigo_articulo_conteo').setValue('');
            this.getField('nombre_articulo_conteo').setValue('');
            this.getField('cantidad_conteo').setValue('');
            this.getField('info_conteo_articulo').setValue('');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    traerInfoArticulo() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                value: this.getField('codigo_articulo_conteo').getValue()
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'maes-articulo', operacion: '42', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucessTraerArticulo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucessTraerArticulo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('nombre_articulo_conteo').setValue(data.data[0].nombre);
            this.traerConteo();
        } else if (data.estado_p === 404) {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos sobre el artículo.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    sucessTraerArticulo2(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.length > 0) {
            //eso es para evitar consumir dos veces el servicio traer articulo cuando prioridad barras esta en N
            //ya que no sería necesari, se guardo la respuesta dle primer servicio y con eso lleno los datos
            if (this.getField('codigo_articulo_conteo').getValue() !== '') {
                data.forEach((element) => {
                    if (element.codigo_interno === this.getField('codigo_articulo_conteo').getValue()) {
                        data[0] = element;
                        return;
                    }
                });
            }
            this.getField('nombre_articulo_conteo').setValue(data[0].nombre);
            this.datos_articulo_aux = [];
        } else {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos sobre el artículo.', 'error');
        }
    }

    changeKeyUpCustom = (e) => {
        let keycode = (e.keyCode ? e.keyCode : e.which);
        //keycode 120 = f9_servicio;
        //keycode 13 = enter_servicio;
        if (keycode === 120) {
            this.operacion_seleccionada = "F9";
        } else {
            this.operacion_seleccionada = "ENTER-BOTON";
        }
        this.getField("codigo_articulo_conteo").changeKeyUp(e);
    }

    traerInfoInicial() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                bodega: this.bodega,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'info_inicial', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerInfoInicial,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerInfoInicial(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.campo_costo = data.data.campo_costo;
            this.por_gondola = data.data.por_gondola;
            this.acumula = data.data.acumula;

            this.cantidad_permitida = data.data.cantidad_permitida;
            this.prioridad_barras = data.data.prioridad_barras;

            this.conteo1 = data.data.conteo1;
            this.conteo2 = data.data.conteo2;
            this.conteo3 = data.data.conteo3;
            this.lista_diferencias1_2 = data.data.lista_diferencias1_2;
            this.diferencias_reales = data.data.diferencias_reales;
            this.tabla_por_gondola = data.data.tabla_por_gondola;
            this.eliminar_articulo = data.data.eliminar_articulo;
            this.puede_asentar = data.data.asentar;
            this.asentar_subgrupo = data.data.asentar_subgrupo;
            
            //especiales
            this.bloquear_inventario = data.data.bloquear_inventario;
            this.asentar_inventario = data.data.asentar_inventario;
            this.actualizar_articulos = data.data.actualizar_articulos;
            this.reiniciar_conteo = data.data.reiniciar_conteo;
            this.diferencias_reales_gandola = data.data.diferencias_reales_gandola;
            this.getField('info_inventario_activo').setVisible(true);

            this.getField('info_inventario_activo').setValue('INVENTARIO FÍSICO - BODEGA ' + this.bodega + (this.wms === 'S' ? ' POR UBICACIONES' : ''));

        } else {
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            } else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            }
        }
    }



    //modal agregar articulos--->

    funcionesAgregarArticulo() {
        this.getField('select_zona').setOnChange(this.cargarRack);
        this.getField('select_rack').setOnChange(this.cargarColumna);
        this.getField('select_columna').setOnChange(this.tipoubicacion);
        this.getField('aceptar').setClick(this.guardarArticuloUbicacion);
        this.getField('cancelar1').setClick(() => { this.getField('modal_ubicacion').handleClose(); });
        this.getField("nombre_articulo_wms").setOnChange(() => {
            this.getField('nombre_articulo_wms').setError(false, '');
        });

    }

    guardarArticuloUbicacion() {

        if (this.getField('codigo_articulo_wms').valid() &&
            this.getField('nombre_articulo_wms').valid() &&
            this.getField('select_bodega').valid() &&
            this.getField('select_zona').valid() &&
            this.getField('select_rack').valid() &&
            this.getField('select_columna').valid() &&
            this.getField('select_nivel').valid() &&
            this.getField('select_tipo_ubicacion').valid()) {
            let datos = {
                datos: {
                    tabla: this.fila_seleccionada[0].tabla,
                    bodega: this.fila_seleccionada[0].bodega,
                    sucursal: this.fila_seleccionada[0].sucursal,
                    wms: this.fila_seleccionada[0].wms,
                    sucursal_ingreso: this.sucursal_ingreso,
                    ch_excluir: 'false',
                    codigo_articulo_wms: this.getField('codigo_articulo_wms').getValue(),
                    select_bodega: this.getField('select_bodega').getValue(),
                    select_zona: this.getField('select_zona').getValue(),
                    select_rack: this.getField('select_rack').getValue(),
                    rack: this.getField('rack').getValue(),
                    select_columna: this.getField('select_columna').getValue(),
                    select_nivel: this.getField('select_nivel').getValue(),
                    select_tipo_ubicacion: this.getField('select_tipo_ubicacion').getValue(),
                }
            }
            this.mostrarMensajeGenerando();
            this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'agregararticulosfinales', operacion_tipo: 'crear' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.successguardarArticuloUbicacion,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        } else {
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }

    }

    successguardarArticuloUbicacion(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.mensaje_mostrar !== undefined) {
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            } else if (data.data.tabla !== undefined) {
                this.sucursal = data.data.sucursal;
                this.tabla = data.data.tabla;
                this.bodega = data.ata.bodega;
                this.alertGeneral.toggle(true, 'Guardado con éxito.', 'success');

                this.getField('modal_ubicacion').handleClose();
                this.getField('modal_asignar').handleClickOpen();
                this.traerInventarios();
                this.crearTemporalUsuarios();
                this.traerUsuarios();

            } else {
                this.alertGeneral.toggle(true, 'Guardado con éxito.', 'success');
                this.getField('modal_ubicacion').handleClose();
                this.traerInventarios();
            }

        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    ubicaiones() {
        this.getField('modal_ubicacion').handleClickOpen();
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal: this.fila_seleccionada[0].sucursal
            }
        };

        this.generalFormatPmv = { tipo_servicio: 'inve-ajustesinventario', operacion: 'cargarsucursal', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successUbicacionesWms,
                error: this.error_,
                general: this.generalFormatPmv
            });
    }

    successUbicacionesWms(data) {
        this.getField('confirmModalCustom').toggle(false);

        if (data.estado_p === 200) {
            this.mostrarMensajeGenerando();
            this.idsucursal = data.data[0].id;
            this.getField('select_sucursal').setValue(data.data[0].nombre);
            this.getField('select_sucursal').setDisabled(true);
            let datos = {
                datos: {
                    sucursal: this.fila_seleccionada[0].sucursal,
                    bodega: this.fila_seleccionada[0].bodega
                }
            };

            this.generalFormatPmv = { tipo_servicio: 'inve-ajustesinventario', operacion: 'cargarbodega', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successBodegaWms,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores.mensaje);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    successBodegaWms(data) {
        this.getField('confirmModalCustom').toggle(false);

        if (data.estado_p === 200) {
            this.mostrarMensajeGenerando();
            this.getField('select_bodega').setValue(data.data[0].nombre);
            this.getField('select_bodega').setDisabled(true);
            let datos = {
                datos: {
                    id: this.idsucursal
                }
            };

            this.generalFormatPmv = { tipo_servicio: 'inve-ajustesinventario', operacion: 'cargarzona', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successZonaWms,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores.mensaje);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    successZonaWms(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {

            let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = item.nombre;
                dataOp['campos_cambian'] = { zona: item.codigo };
                opciones.push(dataOp);
            });
            this.getField('select_zona').setOptions(opciones);
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores.mensaje);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    cargarRack() {
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        this.getField('select_rack').setOptions(opciones);
        this.getField('select_columna').setOptions(opciones);
        this.getField('select_nivel').setOptions(opciones);


        this.getField('select_tipo_ubicacion').setValue('');
        this.getField('select_columna').setValue(' ');
        this.getField('select_rack').setValue(' ');

        this.getField('select_nivel').setValue(' ');
        if (this.getField("select_zona").getValue().toString().trim() !== "") {
            let datos = {
                datos: {
                    select_zona: this.getField("select_zona").getValue()
                }
            };

            this.generalFormatPmv = { tipo_servicio: 'inve-ajustesinventario', operacion: 'cargarrack', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successRackwms,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }

    successRackwms(data) {
        if (data.estado_p === 200) {
            let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = item.numero;
                dataOp['campos_cambian'] = { rack: item.numero };
                opciones.push(dataOp);
            });
            this.getField('select_rack').setOptions(opciones);
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores.mensaje);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    cargarColumna() {
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        this.getField('select_columna').setOptions(opciones);
        this.getField('select_nivel').setOptions(opciones);
        this.getField('select_tipo_ubicacion').setValue('');
        this.getField('select_columna').setValue(' ');
        this.getField('select_nivel').setValue(' ');

        if (this.getField("select_rack").getValue().toString().trim() !== "") {
            let datos = {
                datos: {
                    select_rack: this.getField("select_rack").getValue()
                }
            };

            this.generalFormatPmv = { tipo_servicio: 'inve-ajustesinventario', operacion: 'cargarcolumna', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successColumnawms,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }

    successColumnawms(data) {
        if (data.estado_p === 200) {
            this.wms_nuevo_rack_id = data.data[0].wms_nuevo_rack_id;
            let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.columna_numero;
                dataOp['text'] = item.columna_numero;
                dataOp['campos_cambian'] = { columna: item.columna_numero };
                opciones.push(dataOp);
            });
            this.getField('select_columna').setOptions(opciones);

            let data2 = { "data": [] };

            for (let index = 1; index <= data.data[0].niveles; index++) {
                data2.data.push(index)
            }

            let opciones2 = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
            data2.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item;
                dataOp['text'] = item;
                dataOp['campos_cambian'] = { nivel: item };
                opciones2.push(dataOp);
            });
            this.getField('select_nivel').setOptions(opciones2);

        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores.mensaje);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    tipoubicacion() {
        this.getField('select_tipo_ubicacion').setValue('');
        if (this.getField("select_columna").getValue().toString().trim() !== "") {
            let datos = {
                datos: {
                    id: this.wms_nuevo_rack_id,
                    select_columna: this.getField("select_columna").getValue()
                }
            };

            this.generalFormatPmv = { tipo_servicio: 'inve-ajustesinventario', operacion: 'tipoubicacion', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successTipoUbicacion,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }

    successTipoUbicacion(data) {
        if (data.estado_p === 200) {
            this.getField('select_tipo_ubicacion').setValue(data.data[0].tipo);
            this.getField('clase').setValue(data.data[0].tipo);
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores.mensaje);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }



    //modal inicial--->

    funcionesIniciarInventario() {

        this.getField('bt_cancelar_iniciar').setClick(() => {
            this.getField('modal_apertura').handleClose();
        });

        this.getField('bt_aceptar_iniciar').setClick(() => {
            this.confirmarIniciar();
        });

    }

    inicioValidaciones() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                tabla: this.tabla,
                sucursal: this.sucursal,
                bodega: this.bodega,
                wms: this.fila_seleccionada[0].wms,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'inicio_validaciones', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucessinicioValidaciones,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucessinicioValidaciones(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.conteo !== undefined && data.data.conteo === 0 && this.bt_iniciar_inventario) {//esto solo se valida cuando le dan en iniciar inventario
                this.mostrarMensajeAdicional('Falta asignar usuarios para el conteo!');
            } else {
                this.getField('modal_apertura').handleClickOpen();
                this.getField('info_iniciar_bodega').setValue(this.bodega + '-' + data.data.nombre_bodega);
                this.getField('info_iniciar_administrador').setValue(data.data.info.usuario2 + '-' + data.data.info.nom2);
                this.getField('info_iniciar_auditoria').setValue(data.data.info.usuario3 + '-' + data.data.info.nom3);

            }

        } else {
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            } else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            }
        }
    }

    confirmarIniciar() {
        if (this.getField('info_iniciar_detalle').valid() && this.getField('info_iniciar_administrador').valid() &&
            this.getField('info_iniciar_auditoria').valid() &&
            this.getField('info_iniciar_detalle').valid() &&
            this.getField('clave_admin').valid() &&
            this.getField('clave_auditoria').valid()) {
            let datos = {
                datos: {
                    admin: this.getField('info_iniciar_administrador').getValue(),
                    audit: this.getField('info_iniciar_auditoria').getValue(),
                    clave_admin: this.getField('clave_admin').getValue(),
                    clave_auditoria: this.getField('clave_auditoria').getValue(),
                    info_iniciar_detalle: this.getField('info_iniciar_detalle').getValue(),
                    id_inventario: this.fila_seleccionada[0].id,
                }
            }
            this.mostrarMensajeGuardando();
            this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'iniciarinventario', operacion_tipo: 'crear' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.successconfirmarIniciar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });

        } else {
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }

    }

    successconfirmarIniciar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.mensaje_mostrar !== undefined) {
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            } else {
                this.getField('modal_apertura').handleClose();
                this.alertGeneral.toggle(true, 'Acción realizada con éxito.', 'success');
                this.traerInventarios();
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }



    //eliminar inventario------>

    eliminarInventario() {
        this.mostrarMensajeGuardando();
        let datos = {
            datos: {
                id_inventario: this.fila_seleccionada[0].id,
                tabla: this.fila_seleccionada[0].tabla,
                bodega: this.fila_seleccionada[0].bodega,
                wms: this.fila_seleccionada[0].wms,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'eliminarinventario', operacion_tipo: 'eliminar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: datos,
                success: this.successEliminarInventario,
                error: this.error_,
                general: this.generalFormatPmv
            });
    }

    successEliminarInventario(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.alertGeneral.toggle(true, 'Acción realizada con éxito.', 'success');
            this.traerInventarios();
        }
        else if (data.estado_p === 404) {
            this.mostrarMensajeNoHayDatos();
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    //modal asignar usuarios------->


    funcionesUsuarios() {

        this.getField('bt_cerrar_asignar_usuario').setClick(() => {
            this.getField('modal_asignar').handleClose();
        });

        this.getField('bt_cambiar_estado').setClick(() => {
            this.cambiarEstado();
        });

        this.getField('bt_cambiar_usuario').setClick(() => {
            this.cambiarUsuario();
        });


    }

    traerUsuarios() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                select_ubicaciones: this.bodega,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: '1_usuarios', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesssuccessTraerUsuarios,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesssuccessTraerUsuarios(data) {
        this.getField('confirmModalCustom').toggle(false);
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        if (data.estado_p === 200) {
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.codigo;
                dataOp['text'] = item.nombre;
                dataOp['campos_cambian'] = '';
                opciones.push(dataOp);
            });
        } else {
            if (data.estado_p === 404) {

            } else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            }
        }
        this.getField('select_usuarios').setOptions(opciones);
        this.getField('select_usuarios_recontar').setOptions(opciones);//al ingresar inventario se cierra el modal anterior
        //no es posible abrir asignar usuarios por tanto no debería haber problema si el select cambia
    }

    traerUsuariosTemp() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'usuariostemp', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerUsuariosTemp,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerUsuariosTemp(data) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('rejilla_ubicaciones_asignar_usuario').toggle(false);
        this.fila_seleccionada_usuarios = []
        if (data.estado_p === 200) {

            this.gridOptionsUsuarios['rowData'] = [];
            let configCell = new Map();
            this.gridOptionsUsuarios['rowData'] = data.data;

            let createElement = this.createElementJaivana;
            configCell.set('estado', {
                cellRenderer: function (props) {
                    if (props.data.estado === '1') {
                        let div = document.createElement("input");
                        div.setAttribute("id", `div_a`);
                        div.setAttribute("value", props.data.estado);
                        div.setAttribute("class", "divStyle4");
                        div.setAttribute("type", "div");
                        return createElement(div);
                    } else {
                        let div = document.createElement("input");
                        div.setAttribute("id", `div_a`);
                        div.setAttribute("value", props.data.estado);
                        div.setAttribute("class", "divStyle5");
                        div.setAttribute("type", "div");
                        return createElement(div);

                    }
                }, field: 'estado'
            });

            this.getField('rejilla_ubicaciones_asignar_usuario').initData(this.gridOptionsUsuarios, configCell);
            this.getField('rejilla_ubicaciones_asignar_usuario').toggle(true);

        } else if (data.estado_p === 404) {
            this.mostrarMensajeNoHayDatos();
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    crearTemporalUsuarios() {
        let datos = {
            datos: {
                tabla: this.tabla,
            }
        }
        this.mostrarMensajeGenerando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'creartemporalasignarusuarios', operacion_tipo: 'crear' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successcrearTemporalUsuarios,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successcrearTemporalUsuarios(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.traerUsuariosTemp();
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    cambiarEstado() {

        if (this.fila_seleccionada_usuarios.length > 0) {
            let datos = {
                datos: {
                    tabla: this.tabla,
                    estado: this.fila_seleccionada_usuarios[0].estado,
                    ubicacion: this.fila_seleccionada_usuarios[0].ubicacion,
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'cambiarestado', operacion_tipo: 'modificar' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: datos,
                    success: this.successcambiarEstado,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        } else {
            this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro.', 'error');
        }
    }

    successcambiarEstado(data) {
        if (data.estado_p === 200) {
            this.traerUsuariosTemp();
        } else if (data.estado_p === 404) {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
        }
    }

    cambiarUsuario() {
        if (this.getField('select_usuarios').valid()) {
            let datos = {
                datos: {
                    tabla: this.tabla,
                    select_usuarios: this.getField('select_usuarios').getValue(),
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'cambiarusuario', operacion_tipo: 'modificar' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: datos,
                    success: this.succcessCambiarUsuario,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }

    succcessCambiarUsuario(data) {
        if (data.estado_p === 200) {
            //tocaría mirar si se puede dejar solo consultar usuarios de nuevo
            if (data.data.mensaje_mostrar !== undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            else
                this.crearTemporalUsuarios();
        } else if (data.estado_p === 404) {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
        }
    }

    onSelectionChangedUsuarios() {
        this.fila_seleccionada_usuarios = this.gridOptionsUsuarios.api.getSelectedRows();
    }





    //modal nuevo--->

    onSelectionChangedNuevo() {
        this.fila_seleccionada_nuevo = this.gridOptionsNuevo.api.getSelectedRows();
    }

    funcionesNuevoInventario() {

        this.getField('ch_grupo').setOnChange((props) => {
            if (this.getField('ch_grupo').getValue() === 'false') {
                this.getField('ch_subgrupo').setValueSwitch(false);
                this.getField('ch_marca').setValueSwitch(false);
                this.getField('ch_articulo').setValueSwitch(false);
                this.getField('ch_sin').setValueSwitch(false);

                this.getField('codigo_grupo').setValue('');
                this.getField('nombre_grupo').setValue('');
                this.getField('codigo_grupo').setError(false, '');
                this.getField('nombre_grupo').setError(false, '');

                this.getField('codigo_grupo').setVisible(true);
                this.getField('nombre_grupo').setVisible(true);

                this.getField('codigo_subgrupo').setVisible(false);
                this.getField('nombre_subgrupo').setVisible(false);

                this.getField('codigo_marca').setVisible(false);
                this.getField('nombre_marca').setVisible(false);

                this.getField('codigo_articulo_nuevo').setVisible(false);
                this.getField('nombre_articulo_nuevo').setVisible(false);
                this.getField('bt_ok_nuevo').setDisabled(false);
            }
        });

        this.getField('ch_subgrupo').setOnChange((props) => {
            if (this.getField('ch_subgrupo').getValue() === 'false') {
                this.getField('ch_grupo').setValueSwitch(false);
                this.getField('ch_marca').setValueSwitch(false);
                this.getField('ch_articulo').setValueSwitch(false);
                this.getField('ch_sin').setValueSwitch(false);

                this.getField('codigo_subgrupo').setValue('');
                this.getField('nombre_subgrupo').setValue('');
                this.getField('codigo_subgrupo').setError(false, '');
                this.getField('nombre_subgrupo').setError(false, '');

                this.getField('codigo_grupo').setVisible(false);
                this.getField('nombre_grupo').setVisible(false);

                this.getField('codigo_subgrupo').setVisible(true);
                this.getField('nombre_subgrupo').setVisible(true);

                this.getField('codigo_marca').setVisible(false);
                this.getField('nombre_marca').setVisible(false);

                this.getField('codigo_articulo_nuevo').setVisible(false);
                this.getField('nombre_articulo_nuevo').setVisible(false);
                this.getField('bt_ok_nuevo').setDisabled(false);
            }
        });

        this.getField('ch_marca').setOnChange((props) => {
            if (this.getField('ch_marca').getValue() === 'false') {
                this.getField('ch_grupo').setValueSwitch(false);
                this.getField('ch_subgrupo').setValueSwitch(false);
                this.getField('ch_articulo').setValueSwitch(false);
                this.getField('ch_sin').setValueSwitch(false);

                this.getField('codigo_marca').setValue('');
                this.getField('nombre_marca').setValue('');
                this.getField('codigo_marca').setError(false, '');
                this.getField('nombre_marca').setError(false, '');

                this.getField('codigo_grupo').setVisible(false);
                this.getField('nombre_grupo').setVisible(false);

                this.getField('codigo_subgrupo').setVisible(false);
                this.getField('nombre_subgrupo').setVisible(false);

                this.getField('codigo_marca').setVisible(true);
                this.getField('nombre_marca').setVisible(true);

                this.getField('codigo_articulo_nuevo').setVisible(false);
                this.getField('nombre_articulo_nuevo').setVisible(false);
                this.getField('bt_ok_nuevo').setDisabled(false);

            }
        });

        this.getField('ch_articulo').setOnChange((props) => {
            if (this.getField('ch_articulo').getValue() === 'false') {
                this.getField('ch_grupo').setValueSwitch(false);
                this.getField('ch_subgrupo').setValueSwitch(false);
                this.getField('ch_marca').setValueSwitch(false);
                this.getField('ch_sin').setValueSwitch(false);

                this.getField('codigo_articulo_nuevo').setValue('');
                this.getField('nombre_articulo_nuevo').setValue('');
                this.getField('codigo_articulo_nuevo').setError(false, '');
                this.getField('nombre_articulo_nuevo').setError(false, '');

                this.getField('codigo_grupo').setVisible(false);
                this.getField('nombre_grupo').setVisible(false);

                this.getField('codigo_subgrupo').setVisible(false);
                this.getField('nombre_subgrupo').setVisible(false);

                this.getField('codigo_marca').setVisible(false);
                this.getField('nombre_marca').setVisible(false);

                this.getField('codigo_articulo_nuevo').setVisible(true);
                this.getField('nombre_articulo_nuevo').setVisible(true);
                this.getField('bt_ok_nuevo').setDisabled(false);
            }
        });

        /*this.getField('ch_sin').setOnChange((props) => {
            if (this.getField('ch_sin').getValue() === 'false') {
                this.getField('ch_grupo').setValueSwitch(false);
                this.getField('ch_subgrupo').setValueSwitch(false);
                this.getField('ch_marca').setValueSwitch(false);
                this.getField('ch_articulo').setValueSwitch(false);


                this.getField('codigo_grupo').setVisible(false);
                this.getField('nombre_grupo').setVisible(false);

                this.getField('codigo_subgrupo').setVisible(false);
                this.getField('nombre_subgrupo').setVisible(false);

                this.getField('codigo_marca').setVisible(false);
                this.getField('nombre_marca').setVisible(false);

                this.getField('codigo_articulo_nuevo').setVisible(false);
                this.getField('nombre_articulo_nuevo').setVisible(false);
                this.getField('bt_ok_nuevo').setDisabled(true);
            }
        });*/

        this.getField('ch_excluir').setOnChange((props) => {
            if (this.getField('ch_excluir').getValue() === 'false') {
                this.getField('info_nuevo').setValue('Excluir por:');
            } else {
                this.getField('info_nuevo').setValue('Agregar por:');

            }
        });

        this.getField('bt_ok_nuevo').setClick(() => {
            this.agregarArticulo();
        });

        this.getField('bt_aceptar_nuevo').setClick(() => {
            this.guardarArticulosFinales();
        });

        this.getField('bt_eliminar_nuevo').setClick(() => {
            if (this.fila_seleccionada_nuevo.length > 0) {
                this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Está seguro de realizar esta acción?');
                this.getField('confirmModalCustom').setClickDialog(this.eliminarArticuloNuevo);
                this.getField("confirmModalCustom").setClickCancelDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
                this.getField('confirmModalCustom').toggle(true);
            } else {
                this.alertGeneral.toggle(true, 'Es necesario seleccionar el inventario a eliminar.', "error");
            }
        });

        this.getField('nombre_grupo').setOnChange(() => {
            this.getField('nombre_grupo').setError(false, '')
        });

        this.getField('nombre_subgrupo').setOnChange(() => {
            this.getField('nombre_subgrupo').setError(false, '')
        });

        this.getField('nombre_marca').setOnChange(() => {
            this.getField('nombre_marca').setError(false, '')
        });

        this.getField('nombre_articulo_nuevo').setOnChange(() => {
            this.getField('nombre_articulo_nuevo').setError(false, '')
        });


    }

    ocultarCampoNuevosArticulos(){
        this.getField('ch_grupo').setValueSwitch(false);
        this.getField('ch_subgrupo').setValueSwitch(false);
        this.getField('ch_marca').setValueSwitch(false);
        this.getField('ch_articulo').setValueSwitch(false);


        this.getField('codigo_grupo').setVisible(false);
        this.getField('nombre_grupo').setVisible(false);

        this.getField('codigo_subgrupo').setVisible(false);
        this.getField('nombre_subgrupo').setVisible(false);

        this.getField('codigo_marca').setVisible(false);
        this.getField('nombre_marca').setVisible(false);


        this.getField('codigo_articulo_nuevo').setVisible(false);
        this.getField('nombre_articulo_nuevo').setVisible(false);
        this.getField('bt_ok_nuevo').setDisabled(true);
    }

    eliminarArticuloNuevo() {
        this.mostrarMensajeGuardando();
        let datos = {
            datos: {
                codigo_articulo_nuevo: this.fila_seleccionada_nuevo[0].codigo,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'eliminararticulonuevo', operacion_tipo: 'eliminar' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: datos,
                success: this.successEliminarArticuloNuevo,
                error: this.error_,
                general: this.generalFormatPmv
            });
    }

    successEliminarArticuloNuevo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (this.gridOptionsNuevo['rowData'].length <= 0)
                this.getField('select_ubicaciones').setDisabled(false);

            this.alertGeneral.toggle(true, 'Acción realizada con éxito.', 'success');
            this.traerArticulosTemp();
        }
        else if (data.estado_p === 404) {
            this.mostrarMensajeNoHayDatos();
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    agregarArticulo() {
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                select_ubicaciones: this.getField('select_ubicaciones').getValue(),
                unificado: this.unificado,
            }
        }
        if (this.unificado === 'S') {
            datos.datos.ch_excluir = this.getField('ch_excluir').getValue();
        } else {
            datos.datos.select_ubicaciones = this.getField('select_ubicaciones').getValue();
        }
        if (this.getField('ch_grupo').getValue() === 'true') {
            if (this.getField('codigo_grupo').valid() && this.getField('nombre_grupo').valid()) {
                datos.datos.codigo_grupo = this.getField('codigo_grupo').getValue();
                datos.datos.input = 'grupo';
            } else {
                return;
            }
        } else if (this.getField('ch_subgrupo').getValue() === 'true') {
            if (this.getField('codigo_subgrupo').valid() && this.getField('nombre_subgrupo').valid()) {
                datos.datos.codigo_subgrupo = this.getField('codigo_subgrupo').getValue();
                datos.datos.input = 'subgrupo';
            } else {
                return;
            }
        } else if (this.getField('ch_marca').getValue() === 'true') {
            if (this.getField('codigo_marca').valid() && this.getField('nombre_marca').valid()) {
                datos.datos.codigo_marca = this.getField('codigo_marca').getValue();
                datos.datos.input = 'marca';
            } else {
                return;
            }
        } else if (this.getField('ch_articulo').getValue() === 'true') {
            if (this.getField('codigo_articulo_nuevo').valid() && this.getField('nombre_articulo_nuevo').valid()) {
                datos.datos.codigo_articulo_nuevo = this.getField('codigo_articulo_nuevo').getValue();
                datos.datos.nombre_articulo_nuevo = this.getField('nombre_articulo_nuevo').getValue();

                datos.datos.input = 'articulo';
            } else {
                return;
            }
        } else {
            return;
        }
        this.mostrarMensajeGenerando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'agregararticulo', operacion_tipo: 'crear' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successAgregarArticulo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successAgregarArticulo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.esPorUbicacion !== undefined && data.data.esPorUbicacion === 'S')
                this.getField('select_ubicaciones').setDisabled(true);

            this.getField('codigo_grupo').setVisible(false);
            this.getField('nombre_grupo').setVisible(false);
            this.getField('codigo_subgrupo').setVisible(false);
            this.getField('nombre_subgrupo').setVisible(false);
            this.getField('codigo_marca').setVisible(false);
            this.getField('nombre_marca').setVisible(false);
            this.getField('codigo_articulo_nuevo').setVisible(false);
            this.getField('nombre_articulo_nuevo').setVisible(false);

            this.getField('ch_grupo').setValueSwitch(false);
            this.getField('ch_subgrupo').setValueSwitch(false);
            this.getField('ch_marca').setValueSwitch(false);
            this.getField('ch_articulo').setValueSwitch(false);
            this.getField('ch_sin').setValueSwitch(false);

            this.getField('nombre_articulo_nuevo').setVisible(false);
            this.getField('nombre_articulo_nuevo').setVisible(false);
            this.getField('nombre_articulo_nuevo').setVisible(false);
            this.getField('nombre_articulo_nuevo').setVisible(false);

            this.getField('codigo_grupo').setValue('');
            this.getField('nombre_grupo').setValue('');
            this.getField('codigo_subgrupo').setValue('');
            this.getField('nombre_subgrupo').setValue('');
            this.getField('codigo_marca').setValue('');
            this.getField('nombre_marca').setValue('');
            this.getField('codigo_articulo_nuevo').setValue('');
            this.getField('nombre_articulo_nuevo').setValue('');

            this.getField('bt_ok_nuevo').setDisabled(true);


            this.traerArticulosTemp();
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    guardarArticulosFinales() {
        let op = ''
        if (this.nuevo) {
            op = 'guardararticulosfinales';
        } else {
            op = 'agregararticulosfinales';
        }
        if(this.getField('select_ubicaciones').valid()){
            if (this.gridOptionsNuevo['rowData'].length !== 0 || this.getField('ch_excluir').getValue() === 'true') {
                let datos = {
                    datos: {
                        sucursal_ingreso: this.sucursal_ingreso,
                        select_ubicaciones: this.getField('select_ubicaciones').getValue(),
                        unificado: this.unificado,
                        ch_excluir: this.getField('ch_excluir').getValue(),
                    }
                }
                if (!this.nuevo) {
                    datos.datos.bodega = this.fila_seleccionada[0].bodega;
                    datos.datos.wms = this.fila_seleccionada[0].wms;
                    datos.datos.tabla = this.fila_seleccionada[0].tabla;
                }
                if (this.unificado === 'S') {
                    //datos.datos.ch_excluir = this.getField('ch_excluir').getValue();
                } else {
                    datos.datos.select_ubicaciones = this.getField('select_ubicaciones').getValue();
                }

                this.mostrarMensajeGenerando();
                this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: op, operacion_tipo: 'crear' };
                this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method: 'POST',
                        body: datos,
                        success: this.successGuardarArticulosFinales,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                    });
            } else {
                this.mostrarMensajeAdicional('Por favor, agregue algún artículo para el inventario o Seleccione la opción sin clasificación para procesar todos los artículos activos.')
            }
        }
    }

    successGuardarArticulosFinales(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if (data.data.mensaje_mostrar !== undefined) {
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            } else if (data.data.tabla !== undefined) {
                this.sucursal = data.data.sucursal;
                this.tabla = data.data.tabla;
                this.bodega = data.ata.bodega;
                this.alertGeneral.toggle(true, 'Guardado con éxito.', 'success');

                this.getField('modal_nuevo').handleClose();
                this.getField('modal_asignar').handleClickOpen();
                this.traerInventarios();
                this.crearTemporalUsuarios();
                this.traerUsuarios();

            } else {
                this.alertGeneral.toggle(true, 'Guardado con éxito.', 'success');
                this.getField('modal_nuevo').handleClose();
                this.traerInventarios();
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    traerArticulosTemp() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'articulostemp', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerArticulosTemp,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerArticulosTemp(data) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('rejilla_nuevo').toggle(false);
        this.fila_seleccionada_nuevo = []
        if (data.estado_p === 200) {

            this.gridOptionsNuevo['rowData'] = [];
            let configCell = new Map();
            this.gridOptionsNuevo['rowData'] = data.data;


            this.getField('rejilla_nuevo').initData(this.gridOptionsNuevo, configCell);
            this.getField('rejilla_nuevo').toggle(true);

        } else if (data.estado_p === 404) {
            this.mostrarMensajeNoHayDatos();
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    crearTemporalNuevo() {
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
            }
        }
        this.mostrarMensajeGenerando();
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'creartemporalnuevo', operacion_tipo: 'crear' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successcrearTemporalNuevo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successcrearTemporalNuevo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {

        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    //modal inicial--->

    funcionesInicial() {
        this.getField('bt_asignar_usuarios').setVisible(false);
        this.traerUbicacionesBodega();
        this.getField('bt_nuevo_inventario').setClick(() => {
            this.nuevo = true;
            if (this.nuevo_inventario) {
                this.ocultarCampoNuevosArticulos();
                this.getField('ch_excluir').setDisabled(false);
                if (this.permite_sumar_bodega === 'S') {
                    this.getField('confirmModalCustom').setTitleAndContent('Crear inventario físico', 'Desea crear conteo en más de una bodega?. Esto permite sumar saldos y conteos en el informe de diferencias reales.');
                    this.getField('confirmModalCustom').setClickDialog(() => {
                        this.getField('select_ubicaciones').setVisible(false);
                        this.getField('ch_excluir').setValueSwitch(false);
                        this.getField('info_nuevo').setValue('Agregar por:');
                        this.unificado = 'S';
                    });
                    this.getField("confirmModalCustom").setClickCancelDialog(() => {
                        this.getField('confirmModalCustom').toggle(false);
                        this.getField('select_ubicaciones').setVisible(true);
                        this.getField('ch_excluir').setValueSwitch(false);
                        this.getField('info_nuevo').setValue('Agregar por:');
                        this.unificado = 'N';
                    });
                    this.getField("confirmModalCustom").setVisibleCancel(false);
                    this.getField("confirmModalCustom").setButtonCancel('NO');
                    this.getField("confirmModalCustom").setButtonConfirm('SI');
                    this.getField('confirmModalCustom').toggle(true);
                } else {
                    this.unificado = 'N';
                    this.getField('select_ubicaciones').setVisible(true);
                    this.getField('ch_excluir').setValueSwitch(false);
                    this.getField('info_nuevo').setValue('Agregar por:');
                }
                this.crearTemporalNuevo();
                this.getField('modal_nuevo').handleClickOpen();
                this.getField('select_ubicaciones').setDisabled(false);
                this.getField('bt_ok_nuevo').setDisabled(true);
            } else
                this.mostrarMensajeAdicional('OPCÓN NO AUTORIZADA! (I0101)');
        });

        this.getField('modal_inicial').setCloseButton(() => {
            //se dezplaza a salir
            this.getField('TabJaivana_263').setTabNumber(4);
            if (!this.ingreso) {
                this.getField("TabJaivana_263").setClickTab(() => {
                    this.getField('TabJaivana_263').setTabNumber(4);
                });//nada
            } else {
                this.getField('TabJaivana_263').setTabNumber(1);
            }
        });

        this.getField('bt_asignar_usuarios').setClick(() => {
            if (this.fila_seleccionada.length > 0) {
                this.sucursal = this.fila_seleccionada[0].sucursal;
                this.tabla = this.fila_seleccionada[0].tabla + '_ubicaciones';
                this.bodega = this.fila_seleccionada[0].bodega;

                this.getField('modal_asignar').handleClickOpen();
                this.crearTemporalUsuarios();
                this.traerUsuarios();
            } else
                this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro.', "error");
        });

        this.getField('bt_eliminar_inventario').setClick(() => {
            if (this.permite_eliminar_inventario) {
                if (this.fila_seleccionada.length > 0) {
                    this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Seguro de Eliminar inventario?');
                    this.getField('confirmModalCustom').setClickDialog(this.eliminarInventario);
                    this.getField("confirmModalCustom").setClickCancelDialog(() => {
                        this.getField('confirmModalCustom').toggle(false);
                    });
                    this.getField("confirmModalCustom").setVisibleCancel(false);
                    this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
                    this.getField('confirmModalCustom').toggle(true);
                } else
                    this.alertGeneral.toggle(true, 'Es necesario seleccionar el inventario a eliminar.', "error");
            } else {
                this.alertGeneral.toggle(true, 'OPCIÓN NO AUTORIZADA! (I0105)', 'error');
            }
        });

        this.getField('bt_agregar_articulos').setClick(() => {
            this.nuevo = false;
            if (this.agregar_inventario) {
                if (this.fila_seleccionada.length > 0) {
                    this.ocultarCampoNuevosArticulos();
                    if (this.fila_seleccionada[0].wms === 'S') {
                        //agregarArticuloUbicacion
                        this.ubicaiones();

                    } else {
                        //normal
                        this.unificado = 'N';
                        this.getField('select_ubicaciones').setVisible(true);
                        this.getField('ch_excluir').setValueSwitch(false);
                        this.getField('ch_excluir').setDisabled(true);
                        this.getField('info_nuevo').setValue('Agregar por:');
                        this.getField('modal_nuevo').handleClickOpen();
                        this.getField('select_ubicaciones').setDisabled(true);
                        this.getField('select_ubicaciones').setValue(this.fila_seleccionada[0].bodega);

                        this.crearTemporalNuevo();
                    }
                } else
                    this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro.', "error");
            } else {
                this.alertGeneral.toggle(true, 'OPCIÓN NO AUTORIZADA! (I0104)', 'error');
            }
        });

        this.getField('bt_iniciar_inventario').setClick(() => {
            if (this.iniciar_inventario) {
                if (this.fila_seleccionada.length > 0) {
                    this.bt_iniciar_inventario=true;//para que valide si el usuario es null

                    this.sucursal = this.fila_seleccionada[0].sucursal;
                    this.tabla = this.fila_seleccionada[0].tabla;
                    this.bodega = this.fila_seleccionada[0].bodega;
                    this.inicioValidaciones();
                } else
                    this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro.', "error");
            } else {
                this.alertGeneral.toggle(true, 'OPCIÓN NO AUTORIZADA! (I0102)', 'error');
            }
        });

        this.getField('bt_ingresar_inventario').setClick(() => {
            if (this.entrar_inventario) {
                if (this.fila_seleccionada.length > 0) {
                    if (this.fila_seleccionada[0].estado === 'A' || this.fila_seleccionada[0].estado === 'C') {
                        this.sucursal = this.fila_seleccionada[0].sucursal;
                        this.tabla = this.fila_seleccionada[0].tabla;
                        this.bodega = this.fila_seleccionada[0].bodega;
                        this.tipo = this.fila_seleccionada[0].tipo;
                        this.wms = this.fila_seleccionada[0].wms;
                        this.ingreso = true;

                        this.bt_iniciar_inventario=false;//para que NO valide si el usuario es null

                        this.getField('modal_inicial').handleClose();
                        this.traerInfoInicial();
                    } else {
                        this.mostrarMensajeAdicional('Inventario no se encuentra en un estado valido para ingresar.');
                    }
                } else
                    this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro.', "error");
            } else {
                this.alertGeneral.toggle(true, 'OPCIÓN NO AUTORIZADA! (I0103)', 'error');
            }
        });


    }

    traerInventarios() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: '1_listadoinventarios', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerInventarios,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerInventarios(data) {
        this.getField('confirmModalCustom').toggle(false);
        this.fila_seleccionada = [];
        this.getField('rejilla_inicial').toggle(false);
        if (data.estado_p === 200) {
            this.getField('bt_ingresar_inventario').setDisabled(true);
            this.getField('bt_eliminar_inventario').setDisabled(true);
            this.getField('bt_iniciar_inventario').setDisabled(true);
            this.getField('bt_agregar_articulos').setDisabled(true);

            this.gridOptionsComponentes['rowData'] = [];
            let configCell = new Map();
            this.gridOptionsComponentes['rowData'] = data.data;


            this.getField('rejilla_inicial').initData(this.gridOptionsComponentes, configCell);
            this.getField('rejilla_inicial').toggle(true);

        } else if (data.estado_p === 404) {
            this.mostrarMensajeNoHayDatos();
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    traerUbicacionesBodega() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: '1_bodegas', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerUbicacionesBodega,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerUbicacionesBodega(data) {
        this.getField('confirmModalCustom').toggle(false);
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        if (data.estado_p === 200) {
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.codigo_bodega;
                dataOp['text'] = item.nombre;
                dataOp['campos_cambian'] = '';
                opciones.push(dataOp);
            });
        } else {
            if (data.estado_p === 404) {

            } else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            }
        }
        this.getField('select_ubicaciones').setOptions(opciones);
    }





    ///generales o comunes ------------>


    traerPropiedades() {
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-abririnventario', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);

        if (data.estado_p === 200) {
            this.numero_decimales = data.data.numero_decimales;
            this.nuevo_inventario = data.data.nuevo_inventario;
            this.permite_sumar_bodega = data.data.permite_sumar_bodega;
            this.permite_eliminar_inventario = data.data.permite_eliminar_inventario;
            this.iniciar_inventario = data.data.iniciar_inventario;
            this.agregar_inventario = data.data.agregar_inventario;
            this.entrar_inventario = data.data.entrar_inventario;
            
            this.getField('modal_inicial').handleClickOpen();
            this.traerInventarios();
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }



    limpiarCamposConteo() {
        this.getField('codigo_articulo_conteo').setError(false, '');
        this.getField('nombre_articulo_conteo').setError(false, '');
        this.getField('info_conteo_articulo').setError(false, '');
        this.getField('cantidad_conteo').setError(false, '');

        this.getField('codigo_articulo_conteo').setValue('');
        this.getField('nombre_articulo_conteo').setValue('');
        this.getField('info_conteo_articulo').setValue('');
        this.getField('cantidad_conteo').setValue('');
    }


    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    mostrarMensajeGuardando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    ///imprimir------->

    procesar() {
        let errores = 0;
        if (this.getField('radio_correo').getValue() === 'S' || this.operacion_actual !== 'pantalla') {
            if (this.getField('email').valid() === false) {
                errores++;
            }
        }
        if (this.getField('ch_excel').getValue() === 'false' && this.getField('ch_pdf').getValue() === 'false' && this.getField('ch_pantalla').getValue() === 'false') {
            errores++;
            this.getField('ch_excel').setError(true, '* Es necesario seleccionar una opción.');
            this.getField('ch_pdf').setError(true, '* Es necesario seleccionar una opción.');
            this.getField('ch_pantalla').setError(true, '* Es necesario seleccionar una opción.');
            this.operacion_actual = '';
            this.alertGeneral.toggle(true, 'Es necesario seleccionar una opción: Pdf,Excel o Pantalla.', 'error');
        }

        if (errores === 0) {
            if (this.operacion_actual !== '') {
                if (this.getField('radio_correo').getValue() === 'S') {
                    this.enviarCorreoTerceros();
                } else {
                    if (this.operacion_actual === 'pdf') {
                        this.generarPdfTabla3();
                    } else if (this.operacion_actual === 'pantalla') {
                        this.genearModalGlobales();
                    } else if (this.operacion_actual === 'excel') {
                        this.generarExcelTabla3();
                    }
                }
            } else {
                this.alertGeneral.toggle(true, 'Error al validar la operación.', 'error');
                this.getField('confirmModalCustom').toggle(false);
            }
        }
    }


    enviarCorreoTerceros() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                email: this.getField('email').getValue(),
                radio_correo: this.getField('radio_correo').getValue(),
                operacion: this.operacion_actual,
            }
        };

        if (this.informes === 'diferencias') {
            datos.datos.tabla = this.tabla;
            datos.datos.bodega = this.bodega;
        } else {
            datos.datos.bodega = this.bodega;
        }
        this.generalFormatPmv = { tipo_servicio: this.tipo_servicio, operacion: this.nombre_servicio, operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successEnviarCorreo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successEnviarCorreo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.mostrarMensajeEmailEnviado();
        } else {
            this.mostrarMensajeEmailFallo();
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }



    generarPdfTabla3() {
        this.mostrarMensajeGenerando();
        let url = this.constant.formConfiguration();
        let datos2 = {
            email: this.getField('email').getValue(),
            radio_correo: this.getField('radio_correo').getValue(),
            sucursal_ingreso: this.sucursal_ingreso,
            operacion: this.operacion_actual,
        };

        if (this.informes === 'diferencias') {
            datos2.tabla = this.tabla;
            datos2.bodega = this.bodega;
        } else {
            datos2.bodega = this.bodega;
        }

        const myJSON = JSON.stringify(datos2);
        let datos = '?body={"datos":' + myJSON + ',"generales":{"tipo_servicio":"' + this.tipo_servicio + '","operacion":"' + this.nombre_servicio + '","operacion_tipo":"consulta"}}';
        fetch(url + datos, {
            method: 'GET',
            headers: new Headers({
                "Authorization": 'Bearer ' + localStorage.getItem('token'),
                "Content-Type": 'application/json'
            })
        })
            .then(response => {
                this.getField('confirmModalCustom').toggle(false);
                if (response.status !== 200) {
                    return '';
                }
                const reader = response.body.getReader();
                return new ReadableStream({
                    start(controller) {
                        return pump();
                        function pump() {
                            return reader.read().then(({ done, value }) => {
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                controller.enqueue(value);
                                return pump();
                            });
                        }
                    }
                })
            })
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if (blob.size > 0) {
                    blob.text().then(res => {
                        if (this.isJson(res)) {
                            this.successEnviarCorreo(JSON.parse(res));
                        } else {
                            const pdf = new File([blob], this.nombre_archivo + '.pdf', {
                                type: 'application/pdf'
                            });
                            window.open(URL.createObjectURL(pdf));
                        }
                    });
                } else {
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.alertGeneral.toggle(true, err, 'error');
            });
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    generarExcelTabla3() {
        this.mostrarMensajeGenerando();
        let url = this.constant.formConfiguration();
        let datos2 = {
            sucursal_ingreso: this.sucursal_ingreso,
            operacion: this.operacion_actual,
            /*                 email: this.getField('email').getValue(),
                            radio_correo: this.getField('radio_correo').getValue(), */
        };

        if (this.informes === 'diferencias') {
            datos2.tabla = this.tabla;
            datos2.bodega = this.bodega;
        } else {
            datos2.bodega = this.bodega;
        }

        const myJSON = JSON.stringify(datos2);
        let datos = '?body={"datos":' + myJSON + ',"generales":{"tipo_servicio":"' + this.tipo_servicio + '","operacion":"' + this.nombre_servicio + '","operacion_tipo":"consulta"}}';
        fetch(url + datos, {
            method: 'GET',
            headers: new Headers({
                "Authorization": 'Bearer ' + localStorage.getItem('token'),
                "Content-Type": 'application/json'
            })
        })
            .then(response => {
                this.getField('confirmModalCustom').toggle(false);
                if (response.status !== 200) {
                    return '';
                }
                const reader = response.body.getReader();
                return new ReadableStream({
                    start(controller) {
                        return pump();
                        function pump() {
                            return reader.read().then(({ done, value }) => {
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                controller.enqueue(value);
                                return pump();
                            });
                        }
                    }
                })
            })
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if (blob.size > 0) {
                    blob.text().then(res => {
                        if (this.isJson(res)) {
                            this.successEnviarCorreo(JSON.parse(res));
                        } else {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.style.display = 'none';
                            a.href = url;
                            // the filename you want
                            a.download = this.nombre_archivo + '.xlsx';
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                            alert('Se descargo el archivo!');
                        }
                    });
                } else {
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.alertGeneral.toggle(true, err, 'error');
            });
    }

    genearModalGlobales() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                operacion: this.operacion_actual,
                email: this.getField('email').getValue(),
                radio_correo: this.getField('radio_correo').getValue(),
                bodega: this.bodega,
            }
        }

        if (this.informes === 'diferencias') {
            datos.datos.tabla = this.tabla;
        } else {
            datos.datos.bodega = this.bodega;
        }

        if (this.nombre_servicio === 'diferenciasarticulos_pag')
            datos.datos.codigo_articulo_aux = this.fila_seleccionada_informes[0].codigo;
        else if (this.nombre_servicio === 'diferenciasubicacion_pag')
            datos.datos.ubicacion = this.fila_seleccionada_informes[0].ubicacion;
        else if (this.nombre_servicio === 'resumenusuario_pag') {
            datos.datos.usuario = this.fila_seleccionada_informes[0].usuario;
            datos.datos.tabla = this.tabla + '_ubicaciones';
        }

        this.getField("rejilla_items_result").setTipoServicioOperacion('inve-abririnventario-' + this.nombre_servicio.replace('_pag', ''));
        this.getField("rejilla_items_result").sendRequest(this.sucessTraerDatos, datos);

    }

    sucessTraerDatos(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            //if(this.informes==='reales'){
            this.getField('total_costo').setVisible(false);
            //}


            let datosFicha = [];
            this.lista = data.data.datos_lista;
            let data2 =
            {
                "empresa": this.lista.empresa,
                "sucursal": this.lista.sucursal,
                "titulo": this.lista.titulo,
                "titulo1": this.lista.titulo1,
                "titulo2": this.lista.titulo2
            };

            datosFicha.push(data2);
            this.getField('lista_datos').setItemsFichas(datosFicha);


            this.getField('rejilla_items_result').toggle(true);

            if (this.nombre_servicio === 'diferenciasgrupos_pag')
                this.getField('modal_result').setLabel('Diferencias Grupos');
            else if (this.nombre_servicio === 'diferenciasmarcas_pag')
                this.getField('modal_result').setLabel('Diferencias Marcas');
            else if (this.nombre_servicio === 'diferenciasresumengrupos_pag')
                this.getField('modal_result').setLabel('Diferencias Resumen Grupos');
            else if (this.nombre_servicio === 'diferenciasarticulos_pag')
                this.getField('modal_result').setLabel('Diferencias Por Artículo ' + this.fila_seleccionada_informes[0].codigo);
            else if (this.nombre_servicio === 'diferenciasubicacion_pag')
                this.getField('modal_result').setLabel('Diferencias Por Ubicación ' + this.fila_seleccionada_informes[0].ubicacion);
            else if (this.nombre_servicio === 'resumenusuario_pag')
                this.getField('modal_result').setLabel('Diferencias Por Usuario ' + this.fila_seleccionada_informes[0].usuario);

            else
                this.getField('modal_result').setLabel('Imprimir');


            this.getField('modal_result').handleClickOpen();
            this.gridOptionsComponentesItems['rowData'] = [];
            let configCell = new Map();
            this.gridOptionsComponentesItems['rowData'] = data.data.datos_items;
            //con ubicacion-->codigo,xnombre,alias,ubicacion_bodega,cantidad,subtota1,tarifa_iva,valor_iva,valor_item
            configCell.set('conteo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('costo_total', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.costo_total) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('diferencia', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.diferencia) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('saldo_bodega', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.saldo_bodega) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('costo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.costo) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('saldo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: { textAlign: "right" }, width: 110 });

            this.getField('rejilla_items_result').initData(this.gridOptionsComponentesItems, configCell);

        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            this.mostrarMensajeNoHayDatos();
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    abrirImprimir() {
        this.getField("modal_imprimir").setLabel("Imprimir");
        this.getField('modal_imprimir').handleClickOpen();
        this.getField('email').setValue('');
        this.getField('email').setError(false, '');
        this.getField('radio_correo').setValue("N");
        this.getField('ch_excel').setValueSwitch(false);
        this.getField('ch_pdf').setValueSwitch(false);
        this.getField('ch_pantalla').setValueSwitch(false);
        if (this.pantalla)
            this.getField('ch_pantalla').setDisabled(false);
        else
            this.getField('ch_pantalla').setDisabled(true);

    }

    deshabilitarCorreo() {
        this.getField('email').setDisabled(true);
        this.getField('email').setValue('');
        this.getField('email').setError(false, '');
        this.getField('radio_correo').setDisabled(true);
        this.getField('radio_correo').setValue("N");
    }

    habilitarCorreo() {
        this.getField('email').setDisabled(false);
        this.getField('radio_correo').setDisabled(false);
        this.getField('radio_correo').setValue("N");
    }


}
FormJaivana.addController("inve-abririnventario", CustomAbrirInventario);
export default CustomAbrirInventario